import { defineMessages } from 'react-intl';
const messages = defineMessages({
  home: {
    id: 'expozed.home',
    defaultMessage: 'Home',
    description: 'Menu item',
  },
  becomeAHost: {
    id: 'expozed.becomeAHost',
    defaultMessage: 'Become a host',
    description: 'Menu item',
  },
  help: {
    id: 'expozed.help',
    defaultMessage: 'Help',
    description: 'Menu item',
  },
  login: {
    id: 'expozed.login',
    defaultMessage: 'Login',
    description: 'Menu item',
  },
  signup: {
    id: 'expozed.signup',
    defaultMessage: 'Sign up',
    description: 'Menu item',
  },
  host: {
    id: 'expozed.host',
    defaultMessage: 'Host',
    description: 'Menu item',
  },
  manageListing: {
    id: 'expozed.manageListing',
    defaultMessage: 'Manage listings',
    description: 'Menu item',
  },
  listYourSpace: {
    id: 'expozed.listYourSpace',
    defaultMessage: 'List Your Space',
    description: 'Menu item',
  },
  yourReservations: {
    id: 'expozed.yourReservations',
    defaultMessage: 'Your Reservations',
    description: 'Menu item',
  },
  transactionHistory: {
    id: 'expozed.transactionHistory',
    defaultMessage: 'Transaction History',
    description: 'Menu item',
  },
  profile: {
    id: 'expozed.profile',
    defaultMessage: 'Profile',
    description: 'Menu item',
  },
  accountSettings: {
    id: 'expozed.accountSettings',
    defaultMessage: 'Account Settings',
    description: 'Menu item',
  },
  trips: {
    id: 'expozed.trips',
    defaultMessage: 'Trips',
    description: 'Menu item',
  },
  messages: {
    id: 'expozed.messages',
    defaultMessage: 'Messages',
    description: 'Menu item',
  },
  dashboard: {
    id: 'expozed.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Menu item',
  },
  editProfile: {
    id: 'expozed.editProfile',
    defaultMessage: 'Edit Profile',
    description: 'Menu item',
  },
  logout: {
    id: 'expozed.logout',
    defaultMessage: 'Logout',
    description: 'Menu item',
  },
  about: {
    id: 'expozed.about',
    defaultMessage: 'About',
    description: 'Menu item',
  },
  careers: {
    id: 'expozed.careers',
    defaultMessage: 'Careers',
    description: 'Menu item',
  },
  press: {
    id: 'expozed.press',
    defaultMessage: 'Press',
    description: 'Menu item',
  },
  policies: {
    id: 'expozed.policies',
    defaultMessage: 'Policies',
    description: 'Menu item',
  },
  discover: {
    id: 'expozed.discover',
    defaultMessage: 'Discover',
    description: 'Menu item',
  },
  trustSafety: {
    id: 'expozed.trustSafety',
    defaultMessage: 'Trust & Safety',
    description: 'Menu item',
  },
  travelCredit: {
    id: 'expozed.travelCredit',
    defaultMessage: 'Travel Credit',
    description: 'Menu item',
  },
  citizen: {
    id: 'expozed.citizen',
    defaultMessage: 'Citizen',
    description: 'Menu item',
  },
  businessTravel: {
    id: 'expozed.businessTravel',
    defaultMessage: 'Business Travel',
    description: 'Menu item',
  },
  guidebooks: {
    id: 'expozed.guidebooks',
    defaultMessage: 'Guidebooks',
    description: 'Menu item',
  },
  hosting: {
    id: 'expozed.hosting',
    defaultMessage: 'Hosting',
    description: 'Menu item',
  },
  whyHost: {
    id: 'expozed.whyHost',
    defaultMessage: 'Why Host',
    description: 'Menu item',
  },
  hospitality: {
    id: 'expozed.hospitality',
    defaultMessage: 'Hospitality',
    description: 'Menu item',
  },
  responsibleHosting: {
    id: 'expozed.responsibleHosting',
    defaultMessage: 'Responsible Hosting',
    description: 'Menu item',
  },
  termsPrivacy: {
    id: 'expozed.termsPrivacy',
    defaultMessage: 'Terms & Privacy',
    description: 'Menu item',
  },
  appsAvailableOn: {
    id: 'expozed.appsAvailableOn',
    defaultMessage: 'Apps available on',
    description: 'Apps available on',
  },
  or: {
    id: 'expozed.or',
    defaultMessage: 'or',
    description: 'or',
  },
  signUp: {
    id: 'expozed.signUp',
    defaultMessage: 'Sign Up',
    description: 'Sign Up Button',
  },
  noAccount: {
    id: 'expozed.noAccount',
    defaultMessage: 'Don’t have an account?',
    description: 'Don’t have an account?',
  },
  firstNameInvalid: {
    id: 'expozed.firstNameInvalid',
    defaultMessage: 'First Name Invalid',
    description: 'First Name is Invalid'
  },
  lastNameInvalid: {
    id: 'expozed.lastNameInvalid',
    defaultMessage: 'Last Name Invalid',
    description: 'Last Name is Invalid'
  },
  email: {
    id: 'expozed.email',
    defaultMessage: 'Email Address',
    description: 'Your Email Address to Login',
  },
  emailRequired: {
    id: 'expozed.emailRequired',
    defaultMessage: 'Email is required',
    description: 'Email is required',
  },
  emailInvalid: {
    id: 'expozed.emailInValid',
    defaultMessage: 'Invalid Email Address',
    description: 'Invalid Email Address',
  },
  taxIdInvalid: {
    id: 'expozed.taxIdInvalid',
    defaultMessage: 'Invalid tax id',
    description: 'Invalid tax id',
  },
  companyRegistrationNumberInvalid: {
    id: 'expozed.companyRegistrationNumberInvalid',
    defaultMessage: 'Invalid company registration number',
    description: 'Invalid company registration number',
  },
  emailNotExists: {
    id: 'expozed.emailNotExists',
    defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
    description: 'Email Address is not exist',
  },
  logoHeight: {
    id: 'expozed.logoHeight',
    defaultMessage: 'Logo height must be numeric value',
    description: 'Logo height must be numeric value'
  },
  logoWidth: {
    id: 'expozed.logoWidth',
    defaultMessage: 'Logo width must be numeric value',
    description: 'Logo width must be numeric value'
  },
  urlInvalid: {
    id: 'expozed.urlInvalid',
    defaultMessage: 'Invalid URL',
    description: 'URL invalid'
  },
  metaDescription: {
    id: 'expozed.metaDescription',
    defaultMessage: 'Description must be 255 characters or less',
    description: 'Description must be 255 characters or less'
  },
  metaKeyword: {
    id: 'expozed.metaKeyword',
    defaultMessage: 'Keyword must be 255 characters or less',
    description: 'Keyword must be 255 characters or less'
  },
  metaTitle: {
    id: 'expozed.metaTitle',
    defaultMessage: 'Meta Title must be 255 characters or less',
    description: 'Meta Title T must be 255 characters or less'
  },
  password: {
    id: 'expozed.password',
    defaultMessage: 'Password',
    description: 'Your Password to Login',
  },
  passwordRequired: {
    id: 'expozed.passwordRequired',
    defaultMessage: 'Password is required',
    description: 'Password is required',
  },
  passwordInvalid: {
    id: 'expozed.passwordInValid',
    defaultMessage: 'Your password must be at least 8 characters. Please try again',
    description: 'Invalid Password',
  },
  passwordWrong: {
    id: 'expozed.passwordWrong',
    defaultMessage: 'Wrong Password. Please try again',
    description: 'Wrong Password',
  },
  userBanned: {
    id: 'expozed.userBanned',
    defaultMessage: 'You are banned by admin. Please contact admin for Unban',
    description: 'You are Banned',
  },
  userBannedTitle: {
    id: 'expozed.userBannedTitle',
    defaultMessage: "We're Sorry!",
    description: 'Not Found',
  },
  userBannedSubTitle: {
    id: 'expozed.userBannedSubTitle',
    defaultMessage: ' It looks like your account is blocked for some reason. If you need further information, please ',
    description: 'Not Found',
  },
  somethingWentWrong: {
    id: 'expozed.somethingWentWrong',
    defaultMessage: 'Sorry, something went wrong. Please try again',
    description: 'Wrong went wrong',
  },
  loggedIn: {
    id: 'expozed.loggedIn',
    defaultMessage: 'You are already logged in!',
    description: 'You are already Logged-in',
  },
  cantLogin: {
    id: 'expozed.cantLogin',
    defaultMessage: 'Can’t Login?',
    description: 'No se puede iniciar sesión?',
  },
  terms1: {
    id: 'expozed.terms1',
    defaultMessage: 'By signing up, I agree to ',
    description: 'Terms content part1',
  },
  terms2: {
    id: 'expozed.terms2',
    defaultMessage: 'Terms of Service, Nondiscrimination Policy, Payments Terms of Service, Privacy Policy, Guest Refund Policy, and Host Guarantee Terms.',
    description: 'Terms content part1',
  },
  signupWithEmail: {
    id: 'expozed.signupWithEmail',
    defaultMessage: 'Signup with Email',
    description: 'Login Modal title',
  },
  facebook: {
    id: 'expozed.facebook',
    defaultMessage: 'Facebook',
    description: 'sign up with facebook',
  },
  twitter: {
    id: 'expozed.twitter',
    defaultMessage: 'Twitter',
    description: 'sign up with twitter',
  },
  google: {
    id: 'expozed.google',
    defaultMessage: 'Google',
    description: 'Signup with Google',
  },
  signupWith: {
    id: 'expozed.signupWith',
    defaultMessage: 'Sign up with',
    description: 'Signup with',
  },
  alreadyHaveAccount: {
    id: 'expozed.alreadyHaveAccount',
    defaultMessage: 'Already have an account?',
    description: 'alreadyHaveAccount',
  },
  termsOfService: {
    id: 'expozed.termsOfService',
    defaultMessage: 'Terms of Service',
    description: 'Terms of Service',
  },
  nonDiscriminationPolicy: {
    id: 'expozed.nonDiscriminationPolicy',
    defaultMessage: 'NonDiscrimination Policy',
    description: 'NonDiscrimination Policy',
  },
  firstName: {
    id: 'expozed.firstName',
    defaultMessage: 'First Name',
    description: 'Your First name to Register',
  },
  firstNameRequired: {
    id: 'expozed.firstNameRequired',
    defaultMessage: 'First name is required',
    description: 'First name Required',
  },
  lastName: {
    id: 'expozed.lastName',
    defaultMessage: 'Last Name',
    description: 'Your Last name to Register',
  },
  lastNameRequired: {
    id: 'expozed.lastNameRequired',
    defaultMessage: 'Last name is required',
    description: 'Last name Required',
  },
  dateOfBirth: {
    id: 'expozed.dateOfBirth',
    defaultMessage: 'Birthday',
    description: 'Your Birthday to Register',
  },
  dateOfBirthRequired: {
    id: 'expozed.dateOfBirthRequired',
    defaultMessage: 'Birthday is required',
    description: 'Birthday Required',
  },
  day: {
    id: 'expozed.day',
    defaultMessage: 'Day',
    description: 'Day of birthday',
  },
  dayRequired: {
    id: 'expozed.dayRequired',
    defaultMessage: 'Day is required',
    description: 'Day is required',
  },
  month: {
    id: 'expozed.month',
    defaultMessage: 'Month',
    description: 'Month of birthday',
  },
  monthRequired: {
    id: 'expozed.monthRequired',
    defaultMessage: 'Month is required',
    description: 'Month is required',
  },
  year: {
    id: 'expozed.year',
    defaultMessage: 'Year',
    description: 'Year of birthday',
  },
  yearRequired: {
    id: 'expozed.yearRequired',
    defaultMessage: 'Year is required',
    description: 'Year is required',
  },
  mustBe18OrOld: {
    id: 'expozed.mustBe18OrOld',
    defaultMessage: 'You must be at least 18 years old',
    description: 'You must at least 18 years old',
  },
  WrongDayChosen: {
    id: 'expozed.WrongDayChosen',
    defaultMessage: 'Wrong day chosen for the month',
    description: 'Wrong day chosen for the month',
  },
  birthDay: {
    id: 'expozed.birthDay',
    defaultMessage: 'Birthday',
    description: 'Birthday',
  },
  paymentTerms: {
    id: 'expozed.paymentTerms',
    defaultMessage: 'Payments Terms of Service',
    description: 'Payments Terms of Service',
  },
  privacyPolicy: {
    id: 'expozed.privacyPolicy',
    defaultMessage: 'Privacy Policy',
    description: 'Privacy Policy',
  },
  guestRefundPolicy: {
    id: 'expozed.guestRefundPolicy',
    defaultMessage: 'Guest Refund Policy',
    description: 'Guest Refund Policy',
  },
  and: {
    id: 'expozed.and',
    defaultMessage: 'and',
    description: 'And',
  },
  hostGuaranteeTerms: {
    id: 'expozed.hostGuaranteeTerms',
    defaultMessage: 'Host Guarantee Terms',
    description: 'Host Guarantee Terms',
  },
  forgotPassword: {
    id: 'expozed.forgotPassword',
    defaultMessage: 'Forgot Password',
    description: 'Forgot Password',
  },
  forgotPasswordInfo: {
    id: 'expozed.forgotPasswordInfo',
    defaultMessage: 'Enter the email address associated with your account, and we’ll email you a link to reset your password.',
    description: 'Forgot password info',
  },
  backToLogin: {
    id: 'expozed.backToLogin',
    defaultMessage: 'Back to login',
    description: 'Back to login',
  },
  sendLink: {
    id: 'expozed.sendLink',
    defaultMessage: 'Send Link',
    description: 'Send Link',
  },
  inbox: {
    id: 'expozed.inbox',
    defaultMessage: 'Inbox',
    description: 'Inbox',
  },
  yourListings: {
    id: 'expozed.yourListings',
    defaultMessage: 'Your Listings',
    description: 'Your Listings',
  },
  yourTrips: {
    id: 'expozed.yourTrips',
    defaultMessage: 'Your Trips',
    description: 'Your Trips',
  },
  account: {
    id: 'expozed.account',
    defaultMessage: 'Account',
    description: 'Account',
  },
  addListing: {
    id: 'expozed.addListing',
    defaultMessage: 'Add New Listings',
    description: ' Add New Listings Button',
  },
  profilePhoto: {
    id: 'expozed.profilePhoto',
    defaultMessage: 'Profile Photo',
    description: 'Profile Photo',
  },
  trustAndVerification: {
    id: 'expozed.trustAndVerification',
    defaultMessage: 'Trust and Verification',
    description: 'Trust and Verification',
  },
  reviews: {
    id: 'expozed.reviews',
    defaultMessage: 'Reviews',
    description: 'Reviews',
  },
  viewProfile: {
    id: 'expozed.viewProfile',
    defaultMessage: 'View Profile',
    description: 'View Profile',
  },
  payoutPreferences: {
    id: 'expozed.payoutPreferences',
    defaultMessage: 'Payout Preferences',
    description: 'Payout Preferences',
  },
  paymentOptions: {
    id: 'expozed.paymentOptions',
    defaultMessage: 'Payment Options',
    description: 'Payout Preferences',
  },
  security: {
    id: 'expozed.security',
    defaultMessage: 'Security',
    description: 'Security',
  },
  where: {
    id: 'expozed.where',
    defaultMessage: 'Where',
    description: 'Where',
  },
  when: {
    id: 'expozed.when',
    defaultMessage: 'When',
    description: 'When',
  },
  guest: {
    id: 'expozed.guest',
    defaultMessage: 'Guest',
    description: 'Guests',
  },
  search: {
    id: 'expozed.search',
    defaultMessage: 'Search',
    description: 'Search',
  },
  homeWhere: {
    id: 'expozed.homeWhere',
    defaultMessage: 'Destination, city, address',
    description: 'Destination, city, address',
  },
  checkIn: {
    id: 'expozed.checkIn',
    defaultMessage: 'Check In',
    description: 'Check In',
  },
  checkOut: {
    id: 'expozed.checkOut',
    defaultMessage: 'Check Out',
    description: 'Check Out',
  },
  recommended: {
    id: 'expozed.recommended',
    defaultMessage: 'Recommended',
    description: 'Recommended Home page Slider title',
  },
  mostViewed: {
    id: 'expozed.mostViewed',
    defaultMessage: 'Most Viewed',
    description: 'Most Viewed Home page Slider title',
  },
  popularLocation: {
    id: 'expozed.popularLocation',
    defaultMessage: 'Popular Locations',
    description: 'Popular Locations Home page Slider title',
  },
  location: {
    id: 'expozed.location',
    defaultMessage: 'Location',
    description: 'Location',
  },
  dates: {
    id: 'expozed.dates',
    defaultMessage: 'Dates',
    description: 'Dates',
  },
  roomType: {
    id: 'expozed.roomType',
    defaultMessage: 'Room Type',
    description: 'Type of Room',
  },
  priceRange: {
    id: 'expozed.priceRange',
    defaultMessage: 'Price Range',
    description: 'Price Range',
  },
  instantBook: {
    id: 'expozed.instantBook',
    defaultMessage: 'Instant Book',
    description: 'Instant Book',
  },
  instantBookInfo: {
    id: 'expozed.instantBookInfo',
    defaultMessage: 'Listings you can book without waiting for host approval.',
    description: 'instant Book Information',
  },
  size: {
    id: 'expozed.size',
    defaultMessage: 'Size',
    description: 'Size',
  },
  anyBed: {
    id: 'expozed.anyBed',
    defaultMessage: 'Any bedrooms',
    description: 'Any bedrooms',
  },
  anyBath: {
    id: 'expozed.anyBath',
    defaultMessage: 'Any bathrooms',
    description: 'Any bathrooms',
  },
  anyBeds: {
    id: 'expozed.anyBeds',
    defaultMessage: 'Any beds',
    description: 'Any beds',
  },
  filter: {
    id: 'expozed.filter',
    defaultMessage: 'Filter',
    description: 'Filter button',
  },
  seeHomes: {
    id: 'expozed.seeHomes',
    defaultMessage: 'See Homes',
    description: 'See Homes',
  },
  rentals: {
    id: 'expozed.rentals',
    defaultMessage: 'Rentals',
    description: 'Rentals',
  },
  rentals2: {
    id: 'expozed.rentals2',
    defaultMessage: 'Rentals',
    description: 'Rentals',
  },
  aminities: {
    id: 'expozed.aminities',
    defaultMessage: 'Amenities',
    description: 'Amenities',
  },
  facilities: {
    id: 'expozed.facilities',
    defaultMessage: 'Facilities',
    description: 'Facilities',
  },
  houseRules: {
    id: 'expozed.houseRules',
    defaultMessage: 'House Rules',
    description: 'House Rules',
  },
  cancel: {
    id: 'expozed.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button',
  },
  cancelTrip: {
    id: 'expozed.cancelTrip',
    defaultMessage: 'Cancel',
    description: 'Cancel',
  },
  applyFilters: {
    id: 'expozed.applyFilters',
    defaultMessage: 'Apply filters',
    description: 'Apply filters button',
  },
  map: {
    id: 'expozed.map',
    defaultMessage: 'Map',
    description: 'Map button for mobile',
  },
  filters: {
    id: 'expozed.filters',
    defaultMessage: 'Filters',
    description: 'Filters button for mobile',
  },
  results: {
    id: 'expozed.results',
    defaultMessage: 'Results',
    description: 'Results button for mobile',
  },
  noResultsTitle: {
    id: 'expozed.noResultsTitle',
    defaultMessage: 'No Results',
    description: 'No results message for search listing',
  },
  noResultsSubTitle: {
    id: 'expozed.noResultsSubTitle',
    defaultMessage: 'Try adjusting your search. Here are some ideas:',
    description: 'No results message for search listing',
  },
  noResultsTerms1: {
    id: 'expozed.noResultsTerms1',
    defaultMessage: 'Change your filters or dates',
    description: 'No results message for search listing',
  },
  noResultsTerms2: {
    id: 'expozed.noResultsTerms2',
    defaultMessage: 'Zoom out on the map',
    description: 'No results message for search listing',
  },
  noResultsTerms3: {
    id: 'expozed.noResultsTerms3',
    defaultMessage: 'Search for a specific city, address',
    description: 'No results message for search listing',
  },
  aboutListing: {
    id: 'expozed.aboutListing',
    defaultMessage: 'About this listing',
    description: 'View listing description',
  },
  contactHost: {
    id: 'expozed.contactHost',
    defaultMessage: 'Contact Host',
    description: 'Contact host button and link',
  },
  theSpace: {
    id: 'expozed.theSpace',
    defaultMessage: 'The space',
    description: 'The space',
  },
  accommodates: {
    id: 'expozed.accommodates',
    defaultMessage: 'Accommodates',
    description: 'The space accommodates',
  },
  bedrooms: {
    id: 'expozed.bedrooms',
    defaultMessage: 'Bedrooms',
    description: 'The space bedrooms',
  },
  bathrooms: {
    id: 'expozed.bathrooms',
    defaultMessage: 'Bathrooms',
    description: 'The space bathrooms',
  },
  bed: {
    id: 'expozed.bed',
    defaultMessage: 'Bed',
    description: 'Bed',
  },
  beds: {
    id: 'expozed.beds',
    defaultMessage: 'Beds',
    description: 'The space beds',
  },
  propertyType: {
    id: 'expozed.propertyType',
    defaultMessage: 'Property type',
    description: 'The space property type',
  },
  sharedSpaces: {
    id: 'expozed.sharedSpaces',
    defaultMessage: 'Shared Spaces',
    description: 'View listing shared spaces',
  },
  prices: {
    id: 'expozed.prices',
    defaultMessage: 'Prices',
    description: 'View listing prices',
  },
  extraPeople: {
    id: 'expozed.extraPeople',
    defaultMessage: 'Extra people',
    description: 'View listing extra people',
  },
  noCharge: {
    id: 'expozed.noCharge',
    defaultMessage: 'No Charge',
    description: 'Extra people no charge',
  },
  cancellations: {
    id: 'expozed.cancellations',
    defaultMessage: 'Cancellations',
    description: 'View listing cancellations',
  },
  viewDetails: {
    id: 'expozed.viewDetails',
    defaultMessage: 'View details',
    description: 'Cancellations view details',
  },
  safetyFeatures: {
    id: 'expozed.safetyFeatures',
    defaultMessage: 'Safety features',
    description: 'View listing Safety features',
  },
  availability: {
    id: 'expozed.availability',
    defaultMessage: 'Availability',
    description: 'View listing availability',
  },
  in: {
    id: 'expozed.in',
    defaultMessage: 'in',
    description: 'in',
  },
  guests: {
    id: 'expozed.guests',
    defaultMessage: 'Guests',
    description: 'Guests',
  },
  bedroom: {
    id: 'expozed.bedroom',
    defaultMessage: 'Bedroom',
    description: 'Bedroom',
  },
  bed: {
    id: 'expozed.bed',
    defaultMessage: 'Bed',
    description: 'Bed',
  },
  noReviewTitle: {
    id: 'expozed.noReviewTitle',
    defaultMessage: 'This place would love your review',
    description: 'View listing no review title',
  },
  noReviewInfo: {
    id: 'expozed.noReviewInfo',
    defaultMessage: 'When you book this place, here’s where your review will show up!',
    description: 'View listing no review info',
  },
  loadMore: {
    id: 'expozed.loadMore',
    defaultMessage: 'Load More',
    description: 'Load more button',
  },
  viewCountInfo: {
    id: 'expozed.viewCountInfo',
    defaultMessage: 'This home is on people minds.',
    description: 'View listing view count details',
  },
  viewCountTotal1: {
    id: 'expozed.viewCountTotal1',
    defaultMessage: 'It’s been viewed',
    description: 'View listing view count details',
  },
  viewCountTotal2: {
    id: 'expozed.viewCountTotal2',
    defaultMessage: 'times in the past week.',
    description: 'View listing view count details',
  },
  neighborhood: {
    id: 'expozed.neighborhood',
    defaultMessage: 'The neighborhood',
    description: 'View listing neighborhood',
  },
  neighborhoodInfo: {
    id: 'expozed.neighborhoodInfo',
    defaultMessage: 'Exact location information is provided after a booking is confirmed.',
    description: 'View listing neighborhoodInfo',
  },
  yourHost: {
    id: 'expozed.yourHost',
    defaultMessage: 'Your Host',
    description: 'View listing your host',
  },
  responseRate: {
    id: 'expozed.responseRate',
    defaultMessage: 'Response rate',
    description: 'View listing response rate',
  },
  responseTime: {
    id: 'expozed.responseTime',
    defaultMessage: 'Response time',
    description: 'View listing response time',
  },
  joinedIn: {
    id: 'expozed.joinedIn',
    defaultMessage: 'Joined in',
    description: 'View listing host joining date',
  },
  contactHostinfo1: {
    id: 'expozed.contactHostinfo1',
    defaultMessage: 'Make sure you share the following',
    description: 'Contact host instructions',
  },
  contactHostinfo2: {
    id: 'expozed.contactHostinfo2',
    defaultMessage: 'Tell',
    description: 'Contact host instructions',
  },
  contactHostinfo3: {
    id: 'expozed.contactHostinfo3',
    defaultMessage: 'a little about yourself',
    description: 'Contact host instructions',
  },
  contactHostinfo4: {
    id: 'expozed.contactHostinfo4',
    defaultMessage: 'What brings you to',
    description: 'Contact host instructions',
  },
  contactHostinfo5: {
    id: 'expozed.contactHostinfo5',
    defaultMessage: 'Who’s joining you',
    description: 'Contact host instructions',
  },
  contactHostinfo6: {
    id: 'expozed.contactHostinfo6',
    defaultMessage: 'What do you love about this listing? Mention it',
    description: 'Contact host instructions',
  },
  contactHostDate: {
    id: 'expozed.contactHostDate',
    defaultMessage: 'When are you traveling',
    description: 'Contact host dates title',
  },
  hostErrorMessage1: {
    id: 'expozed.hostErrorMessage1',
    defaultMessage: 'Please specify check in and check out',
    description: 'Contact host error message',
  },
  hostErrorMessage2: {
    id: 'expozed.hostErrorMessage2',
    defaultMessage: 'Those dates are not available',
    description: 'Contact host error message',
  },
  hostErrorMessage3: {
    id: 'expozed.hostErrorMessage3',
    defaultMessage: 'You can contact the host now',
    description: 'Contact host error message',
  },
  chooseGuests: {
    id: 'expozed.chooseGuests',
    defaultMessage: 'Choose Guests',
    description: 'Contact host choose guests dropdown',
  },
  textBoxMessage: {
    id: 'expozed.textBoxMessage',
    defaultMessage: 'Start your message',
    description: 'Contact host text box start your message',
  },
  sendMessage: {
    id: 'expozed.sendMessage',
    defaultMessage: 'Send message',
    description: 'Contact host button',
  },
  contacthostError1: {
    id: 'expozed.contacthostError1',
    defaultMessage: 'You must select number of guests',
    description: 'Contact host error message',
  },
  contacthostError2: {
    id: 'expozed.contacthostError2',
    defaultMessage: 'Message is required',
    description: 'Contact host error message',
  },
  maximumCharcter: {
    id: 'expozed.maximumCharcter',
    defaultMessage: '(Allows Maximum 50 characters)',
    description: 'maximumCharcter',
  },
  emptySpace: {
    id: 'expozed.emptySpace',
    defaultMessage: 'Invalid input ',
    description: 'emptySpace',
  },
  maximumCharcterLeft: {
    id: 'expozed.maximumCharcterLeft',
    defaultMessage: 'characters left.',
    description: 'maximumCharcterLeft',
  },
  serviceFee: {
    id: 'expozed.serviceFee',
    defaultMessage: 'Service fee',
    description: 'Bill details',
  },
  cleaningFee: {
    id: 'expozed.cleaningFee',
    defaultMessage: 'Cleaning fee',
    description: 'Bill details',
  },
  total: {
    id: 'expozed.total',
    defaultMessage: 'Total',
    description: 'Bill details',
  },
  nights: {
    id: 'expozed.nights',
    defaultMessage: 'nights',
    description: 'Bill details',
  },
  checkAvailability: {
    id: 'expozed.checkAvailability',
    defaultMessage: 'Check Availability',
    description: 'Booking button',
  },
  viewOtherListings: {
    id: 'expozed.viewOtherListings',
    defaultMessage: 'View Other Listings',
    description: 'Booking button',
  },
  book: {
    id: 'expozed.book',
    defaultMessage: 'Book',
    description: 'Booking button',
  },
  requestToBook: {
    id: 'expozed.requestToBook',
    defaultMessage: 'Request to Book',
    description: 'Booking button',
  },
  maximumStay: {
    id: 'expozed.maximumStay',
    defaultMessage: 'Maximum stay is',
    description: 'Maximum day error',
  },
  perDay: {
    id: 'expozed.perDay',
    defaultMessage: 'Per Night',
    description: 'Per Night',
  },
  bookingInfo: {
    id: 'expozed.bookingInfo',
    defaultMessage: 'You won’t be charged yet',
    description: 'You won’t be charged yet',
  },
  viewPhotos: {
    id: 'expozed.viewPhotos',
    defaultMessage: 'View Photos',
    description: 'View photos button',
  },
  cancellationPolicies: {
    id: 'expozed.cancellationPolicies',
    defaultMessage: 'Cancellation Policies',
    description: 'Cancellation Policies',
  },
  flexible: {
    id: 'expozed.flexible',
    defaultMessage: 'Flexible',
    description: 'Flexible',
  },
  moderate: {
    id: 'expozed.moderate',
    defaultMessage: 'Moderate',
    description: 'Moderate',
  },
  strict: {
    id: 'expozed.strict',
    defaultMessage: 'Strict',
    description: 'Strict',
  },
  addProfilePhoto: {
    id: 'expozed.addProfilePhoto',
    defaultMessage: 'Add your profile photo',
    description: 'Avatar upload title',
  },
  uploadInfo: {
    id: 'expozed.uploadInfo',
    defaultMessage: 'This helps your host recognize you when you meet, so make sure it shows your face.',
    description: 'Avatar upload info',
  },
  continue: {
    id: 'expozed.continue',
    defaultMessage: 'Continue',
    description: 'Continue button',
  },
  dropzoneUpload: {
    id: 'expozed.dropzoneUpload',
    defaultMessage: 'Upload a file from your computer',
    description: 'Dropzone upload info',
  },
  dropzoneUploadError: {
    id: 'expozed.dropzoneUploadError',
    defaultMessage: 'Remove the existing image and try upload again',
    description: 'Dropzone upload error message',
  },
  meetupTitle: {
    id: 'expozed.meetupTitle',
    defaultMessage: 'Get ready to book with',
    description: 'Get ready to book with',
  },
  meetupInfo1: {
    id: 'expozed.meetupInfo1',
    defaultMessage: 'We ask everyone to confirm a few things before traveling or hosting.',
    description: 'Meetup information',
  },
  meetupInfo2: {
    id: 'expozed.meetupInfo2',
    defaultMessage: 'You’ll only have to do this once.',
    description: 'Meetup information',
  },
  next: {
    id: 'expozed.next',
    defaultMessage: 'Next',
    description: 'Next button',
  },
  checkEmail: {
    id: 'expozed.checkEmail',
    defaultMessage: 'Check your email',
    description: 'Email verification title',
  },
  verificationInfo1: {
    id: 'expozed.verificationInfo1',
    defaultMessage: 'Tap the link in the email we sent you.',
    description: 'Verification info',
  },
  verificationInfo2: {
    id: 'expozed.verificationInfo2',
    defaultMessage: 'Confirming your email address helps us send you trip information.',
    description: 'Verification info',
  },
  resendEmail: {
    id: 'expozed.resendEmail',
    defaultMessage: 'Resend email',
    description: 'Resend email button',
  },
  changeEmail: {
    id: 'expozed.changeEmail',
    defaultMessage: 'Change email address',
    description: 'Change email address',
  },
  aboutYourTrip: {
    id: 'expozed.aboutYourTrip',
    defaultMessage: 'About Your Trip',
    description: 'Payment About Your Trip',
  },
  whoComing: {
    id: 'expozed.whoComing',
    defaultMessage: 'Who\'s Coming',
    description: 'Who\'s Coming',
  },
  sayHello: {
    id: 'expozed.sayHello',
    defaultMessage: 'Say hello to your host and tell them why you’re coming',
    description: 'Payment page info',
  },
  descriptionInfo: {
    id: 'expozed.descriptionInfo',
    defaultMessage: 'Visiting family or friends? Sight seeing? This helps your host plan for your trip.',
    description: 'Payment description information',
  },
  payment: {
    id: 'expozed.payment',
    defaultMessage: 'Payment',
    description: 'Payment',
  },
  paymentInfo: {
    id: 'expozed.paymentInfo',
    defaultMessage: 'You’ll only be charged if your request is accepted by the host.They’ll have 24 hours to accept or decline.',
    description: 'Payment information',
  },
  paymentCurrency: {
    id: 'expozed.paymentCurrency',
    defaultMessage: 'Payment Currency',
    description: 'Payment currency',
  },
  chooseCurrency: {
    id: 'expozed.chooseCurrency',
    defaultMessage: 'Choose Currency',
    description: 'Choose Currency',
  },
  paymentType: {
    id: 'expozed.paymentType',
    defaultMessage: 'Payment Type',
    description: 'Payment Type',
  },
  paypal: {
    id: 'expozed.paypal',
    defaultMessage: 'PayPal',
    description: 'Paypal',
  },
  loginInfo: {
    id: 'expozed.loginInfo',
    defaultMessage: 'Log into PayPal. You will be able to review your request before it is final.',
    description: 'Login information',
  },
  currencyError: {
    id: 'expozed.currencyError',
    defaultMessage: 'Choose a payment currency',
    description: 'Currency Error',
  },
  hostedBy: {
    id: 'expozed.hostedBy',
    defaultMessage: 'Hosted by',
    description: 'Hosted by',
  },
  cancellationPolicy: {
    id: 'expozed.cancellationPolicy',
    defaultMessage: 'Cancellation policy',
    description: 'Cancellation policy',
  },
  deleteListing: {
    id: 'expozed.deleteListing',
    defaultMessage: 'Delete this Listing',
    description: 'Manage listing delete this listing',
  },
  deleteListingInfo: {
    id: 'expozed.deleteListingInfo',
    defaultMessage: 'Are you sure you want to delete this listing? You cannot reverse this action.',
    description: 'Manage listing delete listing information',
  },
  delete: {
    id: 'expozed.delete',
    defaultMessage: 'Delete',
    description: 'Manage listing Delete button',
  },
  goBack: {
    id: 'expozed.goBack',
    defaultMessage: 'Go Back',
    description: 'Manage listing Go back button',
  },
  progressBarText1: {
    id: 'expozed.progressBarText1',
    defaultMessage: 'You’re',
    description: 'Manage listing Progress bar text',
  },
  progressBarText2: {
    id: 'expozed.progressBarText2',
    defaultMessage: 'done with your listing',
    description: 'Manage listing Progress bar text',
  },
  listingUpdateInfo: {
    id: 'expozed.listingUpdateInfo',
    defaultMessage: 'Last updated on',
    description: 'Manage listing update info',
  },
  editListing: {
    id: 'expozed.editListing',
    defaultMessage: 'Edit listing',
    description: 'Manage listing button',
  },
  finishListing: {
    id: 'expozed.finishListing',
    defaultMessage: 'Finish the Listings',
    description: 'Manage listing button',
  },
  preview: {
    id: 'expozed.preview',
    defaultMessage: 'Preview',
    description: 'Manage listing button',
  },
  listed: {
    id: 'expozed.listed',
    defaultMessage: 'Listed',
    description: 'Manage listing dropdown',
  },
  unListed: {
    id: 'expozed.unListed',
    defaultMessage: 'Unlisted',
    description: 'Manage listing dropdown',
  },
  title: {
    id: 'expozed.title',
    defaultMessage: 'You don\'t have any listings!',
    description: 'You don\'t have any listings!',
  },
  content: {
    id: 'expozed.content',
    defaultMessage: 'Make money by renting out your extra space. You\'ll also get to meet interesting travellers from around the world!',
    description: 'content',
  },
  button: {
    id: 'expozed.button',
    defaultMessage: 'Post a new listing',
    description: 'Post a new listing',
  },
  noTripTitle1: {
    id: 'expozed.noTripTitle1',
    defaultMessage: 'You don\'t have any upcoming trips!',
    description: 'No trips title',
  },
  noTripTitle2: {
    id: 'expozed.noTripTitle2',
    defaultMessage: 'Choose your next adventure right away!',
    description: 'No trips title',
  },
  noTripsButton: {
    id: 'expozed.noTripsButton',
    defaultMessage: 'Search listings',
    description: 'No trips button',
  },
  noReservation: {
    id: 'expozed.noReservation',
    defaultMessage: 'You don\'t have any upcoming reservations!',
    description: 'No reservation',
  },
  status: {
    id: 'expozed.status',
    defaultMessage: 'Status',
    description: 'Status',
  },
  dateLocation: {
    id: 'expozed.dateLocation',
    defaultMessage: 'Dates and Location',
    description: 'Dates and Location',
  },
  details: {
    id: 'expozed.details',
    defaultMessage: 'Details',
    description: 'Details',
  },
  noList: {
    id: 'expozed.noList',
    defaultMessage: 'No List Found',
    description: 'No List Found',
  },
  notexist: {
    id: 'expozed.notexist',
    defaultMessage: 'Guest profile doesn\'t exist',
    description: 'Guest profile not exist',
  },
  messageHistroy: {
    id: 'expozed.messageHistroy',
    defaultMessage: 'Message History',
    description: 'Message History',
  },
  contactSupport: {
    id: 'expozed.contactSupport',
    defaultMessage: 'Contact Support',
    description: 'Contact Support',
  },
  viewItinerary: {
    id: 'expozed.viewItinerary',
    defaultMessage: 'View Itinerary',
    description: 'View Itinerary',
  },
  viewReceipt: {
    id: 'expozed.viewReceipt',
    defaultMessage: 'View Receipt',
    description: 'View Receipt',
  },
  approve: {
    id: 'expozed.approve',
    defaultMessage: 'Approve',
    description: 'Approve',
  },
  decline: {
    id: 'expozed.decline',
    defaultMessage: 'Decline',
    description: 'Decline',
  },
  firstName: {
    id: 'expozed.firstName',
    defaultMessage: 'First Name',
    description: 'Your First name to Register',
  },
  firstNameRequired: {
    id: 'expozed.firstNameRequired',
    defaultMessage: 'First name is required',
    description: 'First name Required',
  },
  lastName: {
    id: 'expozed.lastName',
    defaultMessage: 'Last Name',
    description: 'Your Last name to Register',
  },
  lastNameRequired: {
    id: 'expozed.lastNameRequired',
    defaultMessage: 'Last name is required',
    description: 'Last name Required',
  },
  email: {
    id: 'expozed.email',
    defaultMessage: 'Email Address',
    description: 'Your Email Address to Login',
  },
  emailRequired: {
    id: 'expozed.emailRequired',
    defaultMessage: 'Email is required',
    description: 'Email is required',
  },
  emailInvalid: {
    id: 'expozed.emailInValid',
    defaultMessage: 'Invalid Email Address',
    description: 'Invalid Email Address',
  },
  emailAlreadyExists: {
    id: 'expozed.emailAlreadyExists',
    defaultMessage: 'That email address is already in use. Please choose different one!',
    description: 'Email Address is already exist',
  },
  iAm: {
    id: 'expozed.iam',
    defaultMessage: 'I am',
    description: 'Gender Label',
  },
  gender: {
    id: 'expozed.gender',
    defaultMessage: 'Gender',
    description: 'Gender Field',
  },
  genderMale: {
    id: 'expozed.genderMale',
    defaultMessage: 'Male',
    description: 'Gender Male',
  },
  genderFemale: {
    id: 'expozed.genderFemale',
    defaultMessage: 'Female',
    description: 'Gender Female',
  },
  genderOther: {
    id: 'expozed.genderOther',
    defaultMessage: 'Other',
    description: 'Gender Other',
  },
  genderRequired: {
    id: 'expozed.genderRequired',
    defaultMessage: 'Gender is required',
    description: 'Gender is required',
  },
  preferredLanguage: {
    id: 'expozed.preferredLanguage',
    defaultMessage: 'Preferred Language',
    description: 'Preferred Language',
  },
  preferredLanguageRequired: {
    id: 'expozed.preferredLanguageRequired',
    defaultMessage: 'Preferred language is required',
    description: 'Preferred language is required',
  },
  preferredCurrency: {
    id: 'expozed.preferredCurrency',
    defaultMessage: 'Preferred Currency',
    description: 'Preferred Currency',
  },
  preferredCurrencyRequired: {
    id: 'expozed.preferredCurrencyRequired',
    defaultMessage: 'Preferred currency is required',
    description: 'Preferred currency is required',
  },
  phoneNumber: {
    id: 'expozed.phoneNumber',
    defaultMessage: 'Phone Number',
    description: 'Phone Number',
  },
  phoneNumberRequired: {
    id: 'expozed.phoneNumberRequired',
    defaultMessage: 'Phone number is required',
    description: 'Phone number is required',
  },
  phoneNumberInvalid: {
    id: 'expozed.phoneNumberInvalid',
    defaultMessage: 'Invalid Phone Number',
    description: 'Phone Number is Invalid',
  },
  phoneNumberLengthInvalid: {
    id: 'expozed.phoneNumberLengthInvalid',
    defaultMessage: 'Mobile Number must be 30 digits or less',
    description: 'Mobile Number must be 30 digits or less'
  },
  liveLocation: {
    id: 'expozed.liveLocation',
    defaultMessage: 'Where You Live',
    description: 'location',
  },
  locationRequired: {
    id: 'expozed.locationRequired',
    defaultMessage: 'Location is required',
    description: 'Location is required',
  },
  info: {
    id: 'expozed.info',
    defaultMessage: 'Describe Yourself',
    description: 'Describe Yourself',
  },
  infoRequired: {
    id: 'expozed.infoRequired',
    defaultMessage: 'Profile info is required',
    description: 'Describe Yourself is Required',
  },
  infoRequiredone: {
    id: 'expozed.infoRequiredone',
    defaultMessage: 'Describe yourself is required',
    description: 'Describe Yourself is Required',
  },

  somethingWentWrong: {
    id: 'expozed.somethingWentWrong',
    defaultMessage: 'Sorry, something went wrong. Please try again',
    description: 'Wrong went wrong',
  },
  notLoggedIn: {
    id: 'expozed.notLoggedIn',
    defaultMessage: 'You are not logged In. Please login to continue!',
    description: 'Wrong went wrong',
  },
  dateOfBirth: {
    id: 'expozed.dateOfBirth',
    defaultMessage: 'Birthday',
    description: 'Your Birthday to Register',
  },
  dateOfBirthRequired: {
    id: 'expozed.dateOfBirthRequired',
    defaultMessage: 'Birthday is required',
    description: 'Birthday Required',
  },
  save: {
    id: 'expozed.save',
    defaultMessage: 'Save',
    description: 'Save Button',
  },
  month: {
    id: 'expozed.month',
    defaultMessage: 'Month',
    description: 'Month of birthday',
  },
  year: {
    id: 'expozed.year',
    defaultMessage: 'Year',
    description: 'Year of birthday',
  },
  day: {
    id: 'expozed.day',
    defaultMessage: 'Day',
    description: 'Day of birthday',
  },
  birthDayRequired: {
    id: 'expozed.birthDayRequired',
    defaultMessage: 'Select your birth date to continue',
    description: 'birthDayRequired',
  },
  mustBe18OrOld: {
    id: 'expozed.mustBe18OrOld',
    defaultMessage: 'You must be at least 18 years old',
    description: 'You must at least 18 years old',
  },
  WrongDayChosen: {
    id: 'expozed.WrongDayChosen',
    defaultMessage: 'Wrong day chosen for the month',
    description: 'Wrong day chosen for the month',
  },
  Required: {
    id: 'expozed.Required',
    defaultMessage: '*Required',
    description: 'Required Heading',
  },
  RequiredDetails: {
    id: 'expozed.RequiredDetails',
    defaultMessage: 'Profile information',
    description: 'Required Heading',
  },
  ChooseLanguage: {
    id: 'expozed.ChooseLanguage',
    defaultMessage: 'Profile information',
    description: 'Choose Language',
  },
  lastNameInfo: {
    id: 'expozed.lastNameInfo',
    defaultMessage: 'Your public profile only shows your first name. When you request a booking, your host will see your first and last name.',
    description: 'lastNameInfo',
  },
  genderInfo: {
    id: 'expozed.genderInfo',
    defaultMessage: 'We use this data for analysis and never share it with other users.',
    description: 'genderInfo',
  },
  emailInfo: {
    id: 'expozed.emailInfo',
    defaultMessage: 'We won’t share your private email address with other users.',
    description: 'emailInfo',
  },
  learnMore: {
    id: 'expozed.learnMore',
    defaultMessage: 'Learn More',
    description: 'learnMore',
  },
  phoneNumberInfo: {
    id: 'expozed.phoneNumberInfo',
    defaultMessage: 'This is only shared once you have a confirmed booking with another user. This is how we can all get in touch.',
    description: 'phoneNumberInfo',
  },
  preferredLanguageInfo: {
    id: 'expozed.preferredLanguageInfo',
    defaultMessage: 'We’ll send you messages in this language.',
    description: 'preferredLanguageInfo',
  },
  preferredCurrencyInfo: {
    id: 'expozed.preferredCurrencyInfo',
    defaultMessage: 'We’ll show you prices in this currency.',
    description: 'preferredCurrencyInfo',
  },
  info1: {
    id: 'expozed.info1',
    defaultMessage: 'Help other people get to know you.',
    description: 'info1',
  },
  info2: {
    id: 'expozed.info2',
    defaultMessage: 'Tell them about the things you like: What are 5 things you can’t live without? Share your favorite travel destinations, books, movies, shows, music, food.',
    description: 'info2',
  },
  info3: {
    id: 'expozed.info3',
    defaultMessage: 'Tell them what it’s like to have you as a guest or host: What’s your style of traveling? Of hosting?',
    description: 'info3',
  },
  info4: {
    id: 'expozed.info4',
    defaultMessage: 'Tell them about you: Do you have a life motto?',
    description: 'info4',
  },
  profilePhotoInfo: {
    id: 'expozed.profilePhotoInfo',
    defaultMessage: 'Clear frontal face photos are an important way for hosts and guests to learn about each other. It’s not much fun to host a landscape! Please upload a photo that clearly shows your face.',
    description: 'Profile photo upload information',
  },
  verifiedInfo: {
    id: 'expozed.verifiedInfo',
    defaultMessage: 'Verified Info',
    description: 'Verified Info',
  },
  verifiedEmail: {
    id: 'expozed.verifiedEmail',
    defaultMessage: 'You have verified your email address',
    description: 'You have verified your email address',
  },
  facebookInfo: {
    id: 'expozed.facebookInfo',
    defaultMessage: 'Sign in with Facebook and discover your trusted connections to hosts and guests all over the world.',
    description: 'Facebook information',
  },
  disconnect: {
    id: 'expozed.disconnect',
    defaultMessage: 'Disconnect',
    description: 'Disconnect button',
  },
  googleInfo: {
    id: 'expozed.googleInfo',
    defaultMessage: 'Connect your account to your Google account for simplicity and ease.',
    description: 'Google information',
  },
  notVerifiedDetails: {
    id: 'expozed.notVerifiedDetails',
    defaultMessage: 'You haven\'t verified any of the below items',
    description: 'Not verified information',
  },
  notVerifiedInfo: {
    id: 'expozed.notVerifiedInfo',
    defaultMessage: 'Not Verified Info',
    description: 'Not Verified Info',
  },
  pleaseVerify: {
    id: 'expozed.pleaseVerify',
    defaultMessage: 'Please verify your email address.',
    description: 'Verify your email address.',
  },
  verifyEmail: {
    id: 'expozed.verifyEmail',
    defaultMessage: 'Verify Email',
    description: 'Verify Email',
  },
  connect: {
    id: 'expozed.connect',
    defaultMessage: 'Connect',
    description: 'Connect button',
  },
  reviewTitle: {
    id: 'expozed.reviewTitle',
    defaultMessage: 'Thank you for reviewing',
    description: 'Review',
  },
  reviewTitle2: {
    id: 'expozed.reviewTitle2',
    defaultMessage: 'Thank you for reviewing your guest. Your review will be visible on their profile.',
    description: 'Review',
  },
  finish: {
    id: 'expozed.finish',
    defaultMessage: 'Finish',
    description: 'Finish button',
  },
  reviewPageTitle: {
    id: 'expozed.reviewPageTitle',
    defaultMessage: 'Describe your experience (required)',
    description: 'Review',
  },
  reviewPageTitle1: {
    id: 'expozed.reviewPageTitle1',
    defaultMessage: 'Your review will be public on your guest profile',
    description: 'Review',
  },
  reviewTextArea: {
    id: 'expozed.reviewTextArea',
    defaultMessage: 'What was it like to host this guest',
    description: 'Review',
  },
  reviewRating: {
    id: 'expozed.reviewRating',
    defaultMessage: 'Overall Rating',
    description: 'Review',
  },
  submit: {
    id: 'expozed.submit',
    defaultMessage: 'Submit',
    description: 'Submit button',
  },
  reviewError1: {
    id: 'expozed.reviewError1',
    defaultMessage: 'Please write your review!',
    description: 'Review',
  },
  reviewError2: {
    id: 'expozed.reviewError2',
    defaultMessage: 'Please rate your review!',
    description: 'Review',
  },
  pastReviewTitle: {
    id: 'expozed.pastReviewTitle',
    defaultMessage: 'Past Reviews You’ve Written',
    description: 'Review',
  },
  noReview: {
    id: 'expozed.noReview',
    defaultMessage: 'There are no reviews about you yet.',
    description: 'Review',
  },
  noReviewPast: {
    id: 'expozed.noReviewPast',
    defaultMessage: 'There are no reviews published by you.',
    description: 'Review',
  },
  response: {
    id: 'expozed.response',
    defaultMessage: 'Response',
    description: 'Review',
  },
  reviewPanelTitle1: {
    id: 'expozed.reviewPanelTitle',
    defaultMessage: 'Reviews About you',
    description: 'Review',
  },
  reviewPanelTitle2: {
    id: 'expozed.reviewPanelTitle2',
    defaultMessage: 'Reviews By you',
    description: 'Review',
  },
  reviewContent: {
    id: 'expozed.reviewContent',
    defaultMessage: 'Nobody to review right now. Looks like it’s time for another trip!',
    description: 'Review',
  },
  submitReviewFor: {
    id: 'expozed.submitReviewFor',
    defaultMessage: 'Submit a public review for',
    description: 'Review',
  },
  writeReview: {
    id: 'expozed.writeReview',
    defaultMessage: 'Write a Review',
    description: 'Review',
  },
  viewLitneray: {
    id: 'expozed.viewLitneray',
    defaultMessage: 'View Itinerary',
    description: 'Review',
  },
  reviewWritten: {
    id: 'expozed.reviewWritten',
    defaultMessage: 'Reviews are written at the end of a reservation. Reviews you’ve received will be visible both here and on your public profile.',
    description: 'Review',
  },
  hey: {
    id: 'expozed.hey',
    defaultMessage: 'Hey I’m',
    description: 'View profile',
  },
  reportUser: {
    id: 'expozed.reportUser',
    defaultMessage: 'Report this user',
    description: 'View profile',
  },
  noVerifications: {
    id: 'expozed.noVerifications',
    defaultMessage: 'No verifications yet',
    description: 'View profile',
  },
  addVerifications: {
    id: 'expozed.addVerifications',
    defaultMessage: 'Add Verifications',
    description: 'View profile',
  },
  emailConfirmed: {
    id: 'expozed.emailConfirmed',
    defaultMessage: 'Email Confirmed',
    description: 'View profile',
  },
  fbConnected: {
    id: 'expozed.fbConnected',
    defaultMessage: 'Facebook Connected',
    description: 'View profile',
  },
  googleConnected: {
    id: 'expozed.googleConnected',
    defaultMessage: 'Google Connected',
    description: 'View profile',
  },
  moreVerifications: {
    id: 'expozed.moreVerifications',
    defaultMessage: 'Add More Verifications',
    description: 'View profile',
  },
  addPayout: {
    id: 'expozed.addPayout',
    defaultMessage: 'Add Payout Method',
    description: 'Payout',
  },
  addPayoutMethod: {
    id: 'expozed.addPayoutMethod',
    defaultMessage: 'Add Payout Method',
    description: 'Add Payout'
  },
  addPayin: {
    id: 'expozed.addPayin',
    defaultMessage: 'Add Payin Method',
    description: 'Payin',
  },
  address1: {
    id: 'expozed.address1',
    defaultMessage: 'Address Line 1',
    description: 'Payout Form',
  },
  address2: {
    id: 'expozed.address2',
    defaultMessage: 'Address Line 2',
    description: 'Payout Form',
  },
  city: {
    id: 'expozed.city',
    defaultMessage: 'City',
    description: 'Payout Form',
  },
  state: {
    id: 'expozed.state',
    defaultMessage: 'State / Province',
    description: 'Payout Form',
  },
  zipCode: {
    id: 'expozed.zipCode',
    defaultMessage: 'ZIP Code / Postal Code',
    description: 'Payout Form',
  },
  postalCode: {
    id: 'expozed.postalCode',
    defaultMessage: 'ZIP Code / Postal Code',
    description: 'Payout Form',
  },
  payoutError1: {
    id: 'expozed.payoutError1',
    defaultMessage: 'Country is required',
    description: 'Payout Form',
  },
  payoutError2: {
    id: 'expozed.payoutError2',
    defaultMessage: 'City is required',
    description: 'Payout Form',
  },
  payoutError3: {
    id: 'expozed.payoutError3',
    defaultMessage: 'State / Province is required',
    description: 'Payout Form',
  },
  payoutError4: {
    id: 'expozed.payoutError4',
    defaultMessage: 'ZIP Code / Postal Code is required',
    description: 'Payout Form',
  },
  payoutError5: {
    id: 'expozed.payoutError5',
    defaultMessage: 'Enter valid email address',
    description: 'Payout Form',
  },
  payoutError6: {
    id: 'expozed.payoutError6',
    defaultMessage: 'Currency is required',
    description: 'Payout Form',
  },
  country: {
    id: 'expozed.country',
    defaultMessage: 'Country',
    description: 'Payout Form',
  },
  chooseCountry: {
    id: 'expozed.chooseCountry',
    defaultMessage: 'Choose Country',
    description: 'Payout Form',
  },
  back: {
    id: 'expozed.back',
    defaultMessage: 'Back',
    description: 'Back button',
  },
  paypalIntro1: {
    id: 'expozed.paypalIntro1',
    defaultMessage: 'PayPal is an online payment processing service that allows you to receive payments from',
    description: 'Paypal intro',
  },
  paypalIntro2: {
    id: 'expozed.paypalIntro2',
    defaultMessage: 'To use PayPal with',
    description: 'Paypal intro',
  },
  paypalIntro3: {
    id: 'expozed.paypalIntro3',
    defaultMessage: 'you must have an existing account with PayPal.',
    description: 'Paypal intro',
  },
  paypalIntro4: {
    id: 'expozed.paypalIntro4',
    defaultMessage: 'Learn more about PayPal',
    description: 'Paypal intro',
  },
  paypalEmail: {
    id: 'expozed.paypalEmail',
    defaultMessage: 'Enter the email address associated with your existing PayPal account.',
    description: 'Paypal email',
  },
  paypalCurrency: {
    id: 'expozed.paypalCurrency',
    defaultMessage: 'In what currency would you like to be paid?',
    description: 'Paypal currency',
  },
  payoutIntro1: {
    id: 'expozed.payoutIntro1',
    defaultMessage: 'Payouts for reservations are released to you the day after your guest checks in, and it takes some additional time for the money to arrive depending on your payout method.',
    description: 'Payout intro',
  },
  payoutIntro2: {
    id: 'expozed.payoutIntro2',
    defaultMessage: 'We can send money to people in United States with these payout methods. Which do you prefer?',
    description: 'Payout intro',
  },
  payoutTitle: {
    id: 'expozed.payoutTitle',
    defaultMessage: 'Method',
    description: 'Payout header',
  },
  payoutTitle1: {
    id: 'expozed.payoutTitle1',
    defaultMessage: 'Processed in',
    description: 'Payout header',
  },
  payoutTitle2: {
    id: 'expozed.payoutTitle2',
    defaultMessage: 'Fees',
    description: 'Payout header',
  },
  payoutTitle3: {
    id: 'expozed.payoutTitle3',
    defaultMessage: 'Currency',
    description: 'Payout header',
  },
  payoutTitle4: {
    id: 'expozed.payoutTitle4',
    defaultMessage: 'Details',
    description: 'Payout header',
  },
  noPaymentFound: {
    id: 'expozed.noPaymentFound',
    defaultMessage: 'No Payment method found',
    description: 'No payment',
  },
  payoutMethod: {
    id: 'expozed.payoutMethod',
    defaultMessage: 'Payout Methods',
    description: 'Payout Method',
  },
  payinMethod: {
    id: 'expozed.payinMethod',
    defaultMessage: 'Payin Methods',
    description: 'Payin Method',
  },
  addPayinMethod: {
    id: 'expozed.addPayinMethod',
    defaultMessage: 'To get paid, you need to set up a payin method',
    description: 'Payin Method',
  },
  paymentReleaseInfo1: {
    id: 'expozed.paymentReleaseInfo1',
    defaultMessage: 'releases payouts about 24 hours after a guest’s scheduled check-in time.',
    description: 'Payout Method',
  },
  paymentReleaseInfo2: {
    id: 'expozed.paymentReleaseInfo2',
    defaultMessage: 'The time it takes for the funds to appear in your account depends on your payout method.',
    description: 'Payout Method',
  },
  payoutTitleBlock1: {
    id: 'expozed.payoutTitleBlock1',
    defaultMessage: 'When you receive a payment for a reservation, we call that payment to you a “payout”. Our secure payment system supports several payout methods, which can be setup and edited here. Your available payout options and currencies differ by country.',
    description: 'Payout Method',
  },
  payoutFaq: {
    id: 'expozed.payoutFaq',
    defaultMessage: 'Visit the Payout FAQ',
    description: 'Payout Method',
  },
  options: {
    id: 'expozed.options',
    defaultMessage: 'Options',
    description: 'Payout Method',
  },
  default: {
    id: 'expozed.default',
    defaultMessage: 'Default',
    description: 'Payout Method',
  },
  ready: {
    id: 'expozed.ready',
    defaultMessage: 'Ready',
    description: 'Payout Method',
  },
  setDefault: {
    id: 'expozed.setDefault',
    defaultMessage: 'Set Default',
    description: 'Payout Method',
  },
  remove: {
    id: 'expozed.remove',
    defaultMessage: 'Remove',
    description: 'Payout Method',
  },
  directDeposit: {
    id: 'expozed.directDeposit',
    defaultMessage: 'Direct Deposit, Paypal, etc..',
    description: 'Payout Method',
  },
  transactionPayout: {
    id: 'expozed.transactionPayout',
    defaultMessage: 'Payout',
    description: 'Transaction history',
  },
  transferTo: {
    id: 'expozed.transferTo',
    defaultMessage: 'Transfer to',
    description: 'Transaction history',
  },
  transferDate: {
    id: 'expozed.transferDate',
    defaultMessage: 'Date',
    description: 'Date',
  },
  transferType: {
    id: 'expozed.transferType',
    defaultMessage: 'Type',
    description: 'Type',
  },
  transferAmount: {
    id: 'expozed.transferAmount',
    defaultMessage: 'Amount',
    description: 'Amount',
  },
  paidOut: {
    id: 'expozed.paidOut',
    defaultMessage: 'Paid Out',
    description: 'Paid Out',
  },
  reservation: {
    id: 'expozed.reservation',
    defaultMessage: 'Reservation',
    description: 'Reservation',
  },
  payTo: {
    id: 'expozed.payTo',
    defaultMessage: 'Pay to',
    description: 'Pay to',
  },
  grossEarnings: {
    id: 'expozed.grossEarnings',
    defaultMessage: 'Gross Earnings',
    description: 'Gross Earnings',
  },
  allListings: {
    id: 'expozed.allListings',
    defaultMessage: 'All listings',
    description: 'All listings',
  },
  noTransactions: {
    id: 'expozed.noTransactions',
    defaultMessage: 'No Transactions',
    description: 'No Transactions',
  },
  transactionsAddPayout: {
    id: 'expozed.transactionsAddPayout',
    defaultMessage: 'Add Payout',
    description: 'Transaction payout',
  },
  completedTransactions: {
    id: 'expozed.completedTransactions',
    defaultMessage: 'Completed Transactions',
    description: 'Completed Transactions',
  },
  futureTransactions: {
    id: 'expozed.futureTransactions',
    defaultMessage: 'Future Transactions',
    description: 'Completed Transactions',
  },
  exportCSV: {
    id: 'expozed.exportCSV',
    defaultMessage: 'Export to CSV',
    description: 'Export to CSV',
  },
  changePassword: {
    id: 'expozed.changePassword',
    defaultMessage: 'Change Your Password',
    description: 'Change Your Password',
  },
  oldPassword: {
    id: 'expozed.oldPassword',
    defaultMessage: 'Old Password',
    description: 'Old Password',
  },
  newPassword: {
    id: 'expozed.newPassword',
    defaultMessage: 'New Password',
    description: 'New Password',
  },
  confirmPassword: {
    id: 'expozed.confirmPassword',
    defaultMessage: 'Confirm Password',
    description: 'Confirm Password',
  },
  updatePassword: {
    id: 'expozed.updatePassword',
    defaultMessage: 'Update Password',
    description: 'Update Password',
  },
  passwordError1: {
    id: 'expozed.passwordError1',
    defaultMessage: 'Old Password is required',
    description: 'Password Error',
  },
  passwordError2: {
    id: 'expozed.passwordError2',
    defaultMessage: 'New Password is required',
    description: 'Password Error',
  },
  passwordError3: {
    id: 'expozed.passwordError3',
    defaultMessage: 'New Password must be minimum 8 characters',
    description: 'Password Error',
  },
  passwordError4: {
    id: 'expozed.passwordError4',
    defaultMessage: 'Confirm Password is required',
    description: 'Password Error',
  },
  passwordError5: {
    id: 'expozed.passwordError5',
    defaultMessage: 'Confirm Password must be minimum 8 characters',
    description: 'Password Error',
  },
  noMessagesTitle: {
    id: 'expozed.noMessagesTitle',
    defaultMessage: 'No Messages yet.',
    description: 'Inbox',
  },
  noMessagesTitle1: {
    id: 'expozed.noMessagesTitle1',
    defaultMessage: 'When hosts respond to your inquiries or booking requests, you\'ll see their messages here.',
    description: 'Inbox',
  },
  traveling: {
    id: 'expozed.traveling',
    defaultMessage: 'Travelling',
    description: 'Traveling',
  },
  errorMessage: {
    id: 'expozed.errorMessage',
    defaultMessage: 'Oops something went wrong, refresh or check back later',
    description: 'Error message',
  },
  receipt: {
    id: 'expozed.receipt',
    defaultMessage: 'Receipt',
    description: 'Receipt',
  },
  customerReceipt: {
    id: 'expozed.customerReceipt',
    defaultMessage: 'Customer Receipt',
    description: 'Customer Receipt',
  },
  confirmationCode: {
    id: 'expozed.confirmationCode',
    defaultMessage: 'Confirmation Code',
    description: 'Confirmation Code',
  },
  name: {
    id: 'expozed.name',
    defaultMessage: 'Name',
    description: 'Name',
  },
  travelDestination: {
    id: 'expozed.travelDestination',
    defaultMessage: 'Travel Destination',
    description: 'Travel Destination',
  },
  duration: {
    id: 'expozed.duration',
    defaultMessage: 'Duration',
    description: 'Duration',
  },
  accommodationType: {
    id: 'expozed.accommodationType',
    defaultMessage: 'Accommodation Type',
    description: 'Accommodation Type',
  },
  accommodationAddress: {
    id: 'expozed.accommodationAddress',
    defaultMessage: 'Accommodation Address',
    description: 'Accommodation Address',
  },
  accommodationHost: {
    id: 'expozed.accommodationHost',
    defaultMessage: 'Accommodation Host',
    description: 'Accommodation Host',
  },
  reservationCharges: {
    id: 'expozed.reservationCharges',
    defaultMessage: 'Reservation Charges',
    description: 'Reservation Charges',
  },
  paymentReceived: {
    id: 'expozed.paymentReceived',
    defaultMessage: 'Payment Received:',
    description: 'Payment Received:',
  },
  receiptInfo1: {
    id: 'expozed.receiptInfo1',
    defaultMessage: 'is authorized to accept accomodation fees on behalf of the Host as their limited agent.',
    description: 'Receipt information',
  },
  receiptInfo2: {
    id: 'expozed.receiptInfo2',
    defaultMessage: 'This means that your payment obligation to the Host is satisfied by your payment to',
    description: 'Receipt information',
  },
  receiptInfo3: {
    id: 'expozed.receiptInfo3',
    defaultMessage: 'Any of the Host\'s disagreements by the Host regarding that payment must be settled between the Host and',
    description: 'Receipt information',
  },
  itinerayTitle: {
    id: 'expozed.itinerayTitle',
    defaultMessage: 'You’re going to',
    description: 'Itinerary',
  },
  reservationCode: {
    id: 'expozed.reservationCode',
    defaultMessage: 'Reservation code:',
    description: 'Itinerary',
  },
  address: {
    id: 'expozed.address',
    defaultMessage: 'Address',
    description: 'Itinerary',
  },
  viewListing: {
    id: 'expozed.viewListing',
    defaultMessage: 'View Listing',
    description: 'View Listing',
  },
  messageHost: {
    id: 'expozed.messageHost',
    defaultMessage: 'Message Host',
    description: 'Itinerary',
  },
  billing: {
    id: 'expozed.billing',
    defaultMessage: 'Billing',
    description: 'Itinerary',
  },
  messageAction1: {
    id: 'expozed.messageAction1',
    defaultMessage: 'You messaged',
    description: 'View message',
  },
  messageAction2: {
    id: 'expozed.messageAction2',
    defaultMessage: 'about their listing',
    description: 'View message',
  },
  messageActionInfo: {
    id: 'expozed.messageActionInfo',
    defaultMessage: 'Most hosts respond within 24 hours. If this listing is your top choice, enter your payment information to officially request a reservation.',
    description: 'View message',
  },
  RequestToBook: {
    id: 'expozed.RequestToBook',
    defaultMessage: 'Request to book',
    description: 'Request to book',
  },
  messageAction3: {
    id: 'expozed.messageAction3',
    defaultMessage: 'Your booking request sent to',
    description: 'View message',
  },
  messageAction4: {
    id: 'expozed.messageAction4',
    defaultMessage: 'for their listing',
    description: 'View message',
  },
  cancelInfo: {
    id: 'expozed.cancelInfo',
    defaultMessage: 'Most hosts respond within 24 hours. If you don\'t want to continue with this host further, you can cancel this request.',
    description: 'View message',
  },
  cancelReservation: {
    id: 'expozed.cancelReservation',
    defaultMessage: 'Cancel Reservation',
    description: 'Cancel Reservation',
  },
  requestDeclined: {
    id: 'expozed.requestDeclined',
    defaultMessage: 'Request declined',
    description: 'Request declined',
  },
  guestDeclinedInfo: {
    id: 'expozed.guestDeclinedInfo',
    defaultMessage: 'Your request is declined by host. You can choose different dates or search for other listing.',
    description: 'Request declined',
  },
  requestApprovedAction1: {
    id: 'expozed.requestApprovedAction1',
    defaultMessage: 'Your booking request approved by',
    description: 'Request approved',
  },
  requestTimeInfo1: {
    id: 'expozed.requestTimeInfo1',
    defaultMessage: 'You have to book within',
    description: 'Request approved',
  },
  requestTimeInfo2: {
    id: 'expozed.requestTimeInfo2',
    defaultMessage: 'or it will expire.',
    description: 'Request approved',
  },
  bookingConfirmedInfo1: {
    id: 'expozed.bookingConfirmedInfo1',
    defaultMessage: 'Your booking is confirmed with',
    description: 'Booking confirmed',
  },
  bookingCanceledInfo: {
    id: 'expozed.bookingCanceledInfo',
    defaultMessage: 'You can contact your host and do necessary arrangements or you can cancel your reservation.',
    description: 'Booking canceld',
  },
  bookingExpiredTitle: {
    id: 'expozed.bookingExpiredTitle',
    defaultMessage: 'Your booking request has expired',
    description: 'Booking expired',
  },
  bookingExpiredInfo: {
    id: 'expozed.bookingExpiredInfo',
    defaultMessage: 'Try sending request again or send an inquiry to get in touch with the host',
    description: 'Booking expired',
  },
  gotoListing: {
    id: 'expozed.gotoListing',
    defaultMessage: 'Go to Listing',
    description: 'Go to Listing',
  },
  bookingRequestCancel1: {
    id: 'expozed.bookingRequestCancel',
    defaultMessage: 'Booking request canceled',
    description: 'Booking request canceled',
  },
  bookingRequestCancel2: {
    id: 'expozed.bookingRequestCance2',
    defaultMessage: 'Your booking request has been canceled.',
    description: 'Your booking request has been canceled.',
  },
  hostAction1: {
    id: 'expozed.hostAction1',
    defaultMessage: 'Invite',
    description: 'Host Action Block.',
  },
  hostAction2: {
    id: 'expozed.hostAction2',
    defaultMessage: 'to book by pre-approving this trip',
    description: 'Host Action Block.',
  },
  hostAction3: {
    id: 'expozed.hostAction3',
    defaultMessage: 'Let',
    description: 'Host Action Block.',
  },
  hostAction4: {
    id: 'expozed.hostAction4',
    defaultMessage: 'know these dates are available by pre-approving them.',
    description: 'Host Action Block.',
  },
  hostResponseTime1: {
    id: 'expozed.hostResponseTime1',
    defaultMessage: 'Respond within',
    description: 'Host Action Block.',
  },
  hostResponseTime2: {
    id: 'expozed.hostResponseTime2',
    defaultMessage: 'to maintain your response rate.',
    description: 'Host Action Block.',
  },
  preApprove: {
    id: 'expozed.preApprove',
    defaultMessage: 'Pre-approve',
    description: 'Pre-approve',
  },
  guestRequest: {
    id: 'expozed.guestRequest',
    defaultMessage: 'sent a request to booking for your listing',
    description: 'Guest Request',
  },
  requestApproved: {
    id: 'expozed.requestApproved',
    defaultMessage: 'Request Approved',
    description: 'Request Approved',
  },
  timeToExpire: {
    id: 'expozed.timeToExpire',
    defaultMessage: 'Your guest have 24 hours to respond to this or it will get expired',
    description: 'Time To Expire',
  },
  declinedInfo: {
    id: 'expozed.declinedInfo',
    defaultMessage: 'Make sure your calendar is up-to-date and that your listing page accurately reflects your house rules and requirements.',
    description: 'Declined Info',
  },
  bookingIsConfirmed: {
    id: 'expozed.bookingIsConfirmed',
    defaultMessage: 'Booking is confirmed',
    description: 'Booking is confirmed',
  },
  contactGuest: {
    id: 'expozed.contactGuest',
    defaultMessage: 'You can contact your guest and do necessary arrangements or you can cancel.',
    description: 'Contact Guest',
  },
  contactGuest: {
    id: 'expozed.contactGuest',
    defaultMessage: 'You can contact your guest and do necessary arrangements or you can cancel.',
    description: 'Contact Guest',
  },
  bookingIsExpired: {
    id: 'expozed.bookingIsExpired',
    defaultMessage: 'Booking request is expired',
    description: 'Booking request is expired',
  },
  bookingIsExpired1: {
    id: 'expozed.bookingIsExpired1',
    defaultMessage: 'booking request is expired.',
    description: 'booking request is expired.',
  },
  bookingRequestCancel3: {
    id: 'expozed.bookingRequestCance3',
    defaultMessage: 'booking request is cancelled.',
    description: 'booking request is cancelled.',
  },
  writeMessage: {
    id: 'expozed.writeMessage',
    defaultMessage: 'Write your message...',
    description: 'Write your message',
  },
  loadMoreMsg: {
    id: 'expozed.loadMoreMsg',
    defaultMessage: 'Load More Messages',
    description: 'Load More Messages',
  },
  noItmesFound: {
    id: 'expozed.noItmesFound',
    defaultMessage: 'No items found',
    description: 'No items found',
  },
  messageStatus1: {
    id: 'expozed.messageStatus1',
    defaultMessage: 'Inquiry',
    description: 'Message Status',
  },
  earnedAmount: {
    id: 'expozed.earnedAmount',
    defaultMessage: 'Earned Amount',
    description: 'Payment details',
  },
  missedEarnings: {
    id: 'expozed.missedEarnings',
    defaultMessage: 'Missed Earnings',
    description: 'Missed Earnings',
  },
  refundAmount: {
    id: 'expozed.refundAmount',
    defaultMessage: 'Refund Amount',
    description: 'Refund Amount',
  },
  cleaningPrice: {
    id: 'expozed.cleaningPrice',
    defaultMessage: 'Cleaning Price',
    description: 'Payment details',
  },
  subTotal: {
    id: 'expozed.subTotal',
    defaultMessage: 'Subtotal',
    description: 'Payment details',
  },
  youEarn: {
    id: 'expozed.youEarn',
    defaultMessage: 'You earn',
    description: 'Payment details',
  },
  tripDetails: {
    id: 'expozed.tripDetails',
    defaultMessage: 'Trip details',
    description: 'Trip details',
  },
  noThreadFound: {
    id: 'expozed.noThreadFound',
    defaultMessage: 'No thread found! If you think something went wrong, please refresh the page',
    description: 'View Message',
  },
  dashBoardHeader: {
    id: 'expozed.dashBoardHeader',
    defaultMessage: 'Welcome to',
    description: 'Dashboard',
  },
  dashBoardInfo: {
    id: 'expozed.dashBoardInfo',
    defaultMessage: 'Check your messages, view upcoming trip information, and find travel inspiration all from your dashboard. Before booking your first stay, make sure to:',
    description: 'Dashboard',
  },
  dashBoardInfo1: {
    id: 'expozed.dashBoardInfo1',
    defaultMessage: 'Upload a photo and write a short bio to help hosts get to know you before inviting you into their home.',
    description: 'Dashboard',
  },
  completeYourProfile: {
    id: 'expozed.completeYourProfile',
    defaultMessage: 'Complete Your Profile',
    description: 'Dashboard',
  },
  allMessages: {
    id: 'expozed.allMessages',
    defaultMessage: 'All Messages',
    description: 'Dashboard',
  },
  hi: {
    id: 'expozed.hi',
    defaultMessage: 'Hi',
    description: 'Hi',
  },
  letYouGetReady: {
    id: 'expozed.letYouGetReady',
    defaultMessage: 'Let’s get you ready to become a host',
    description: 'Let You Get Ready',
  },
  whatKindOfPlace: {
    id: 'expozed.whatKindOfPlace',
    defaultMessage: 'What kind of place do you have?',
    description: 'What Kind Of Place',
  },
  change: {
    id: 'expozed.change',
    defaultMessage: 'Change',
    description: 'Change Link',
  },
  whatKindOfPlaceListing: {
    id: 'expozed.whatKindOfPlaceListing',
    defaultMessage: 'What kind of place are you listing?',
    description: 'What Kind Of Place Listing',
  },
  whatTypeOfProperty: {
    id: 'expozed.whatTypeOfProperty',
    defaultMessage: 'What type of property is this?',
    description: 'What Type Of Property',
  },
  whatGuestHave: {
    id: 'expozed.whatGuestHave',
    defaultMessage: 'What will guests have?',
    description: 'What will guests have',
  },
  howManyRooms: {
    id: 'expozed.howManyRooms',
    defaultMessage: 'How many total rooms does your property have?',
    description: 'How many total rooms does your property have?',
  },
  isPersonalHome: {
    id: 'expozed.isPersonalHome',
    defaultMessage: 'Is this your personal home?',
    description: 'Is this your personal home?',
  },
  isPersonalHomeInfo: {
    id: 'expozed.isPersonalHomeInfo',
    defaultMessage: 'Guests like to know if this is a place you live and keep your personal belongings in.',
    description: 'Personal Home Info',
  },
  skip: {
    id: 'expozed.skip',
    defaultMessage: 'Skip now',
    description: 'Skip Button',
  },
  howManyGuests: {
    id: 'expozed.howManyGuests',
    defaultMessage: 'How many guests can your place accommodate?',
    description: 'How many guests can your place accommodate?',
  },
  howManyBeds: {
    id: 'expozed.howManyBeds',
    defaultMessage: 'How many beds can guests use?',
    description: 'How many beds can guests use?',
  },
  howManyBedrooms: {
    id: 'expozed.howManyBedrooms',
    defaultMessage: 'How many bedrooms can guests use?',
    description: 'How many bedrooms can guests use?',
  },
  howManyGuestsStay: {
    id: 'expozed.howManyGuestsStay',
    defaultMessage: 'How many guests can stay?',
    description: 'How many guests can stay?',
  },
  howManyBathrooms: {
    id: 'expozed.howManyBathrooms',
    defaultMessage: 'How many bathrooms?',
    description: 'How many bathrooms?',
  },
  whereLocated: {
    id: 'expozed.whereLocated',
    defaultMessage: 'Where’s your place located?',
    description: 'Where’s your place located?',
  },
  bathroom: {
    id: 'expozed.bathroom',
    defaultMessage: 'bathroom',
    description: 'Bathroom',
  },
  yourFullAddress: {
    id: 'expozed.yourFullAddress',
    defaultMessage: 'Your Full Address',
    description: 'Your Full Address',
  },
  street: {
    id: 'expozed.street',
    defaultMessage: 'Street Address',
    description: 'Street Address',
  },
  buildingName: {
    id: 'expozed.buildingName',
    defaultMessage: 'Apt, Suite, Bldg. (optional)',
    description: 'Building Name',
  },
  zipcode: {
    id: 'expozed.zipcode',
    defaultMessage: 'ZIP Code',
    description: 'ZIP Code',
  },
  countryRequired: {
    id: 'expozed.countryRequired',
    defaultMessage: 'Country is Required',
    description: 'countryRequired',
  },
  stateRequired: {
    id: 'expozed.stateRequired',
    defaultMessage: 'State is Required',
    description: 'stateRequired',
  },
  cityRequired: {
    id: 'expozed.cityRequired',
    defaultMessage: 'City is Required',
    description: 'cityRequired',
  },
  streetRequired: {
    id: 'expozed.streetRequired',
    defaultMessage: 'Street is Required',
    description: 'streetRequired',
  },
  zipcodeRequired: {
    id: 'expozed.zipcodeRequired',
    defaultMessage: 'Zip Code is Required',
    description: 'zipcodeRequired',
  },
  houseTypeRequired: {
    id: 'expozed.houseTypeRequired',
    defaultMessage: 'House Type is Required',
    description: 'House Type is Required',
  },
  somethingWentWrong: {
    id: 'expozed.somethingWentWrong',
    defaultMessage: 'Sorry, something went wrong. Please try again',
    description: 'Wrong went wrong',
  },
  notLoggedIn: {
    id: 'expozed.notLoggedIn',
    defaultMessage: 'You are not logged In. Please login to continue!',
    description: 'Wrong went wrong',
  },
  adminLoggedIn: {
    id: 'expozed.adminLoggedIn',
    defaultMessage: 'You are logged in as admin, you can\'t perform this action!',
    description: 'adminLoggedIn',
  },
  whatamenities: {
    id: 'expozed.whatamenities',
    defaultMessage: 'What amenities do you offer?',
    description: 'Amenities Headline',
  },
  safetyamenities: {
    id: 'expozed.safetyamenities',
    defaultMessage: 'Safety amenities',
    description: 'Safety amenities Headline',
  },
  whatSpace: {
    id: 'expozed.whatSpace',
    defaultMessage: 'What spaces can guests use?',
    description: 'What spaces can guests use?',
  },
  step1Heading: {
    id: 'expozed.step1Heading',
    defaultMessage: 'Become a host',
    description: 'STEP 1 Heading',
  },
  step2Heading: {
    id: 'expozed.step2Heading',
    defaultMessage: 'STEP 2',
    description: 'STEP 2 Heading',
  },
  step3Heading: {
    id: 'expozed.step3Heading',
    defaultMessage: 'STEP 3',
    description: 'STEP 3 Heading',
  },
  step1SubHeading: {
    id: 'expozed.step1SubHeading',
    defaultMessage: 'Start with the basics',
    description: 'STEP 1 Sub Heading',
  },
  step2SubHeading: {
    id: 'expozed.step2SubHeading',
    defaultMessage: 'Set the scene',
    description: 'STEP 2 Sub Heading',
  },
  step3SubHeading: {
    id: 'expozed.step3SubHeading',
    defaultMessage: 'Get ready for guests',
    description: 'STEP 3 Sub Heading',
  },
  step1HeadingContent: {
    id: 'expozed.step1HeadingContent',
    defaultMessage: 'Beds, bathrooms, amenities, and more',
    description: 'STEP 1 Heading Content',
  },
  step2HeadingContent: {
    id: 'expozed.step2HeadingContent',
    defaultMessage: 'Photos, short description, title',
    description: 'STEP 2 Heading Content',
  },
  step3HeadingContent: {
    id: 'expozed.step3HeadingContent',
    defaultMessage: 'Booking settings, calendar, price',
    description: 'STEP 3 Heading Content',
  },
  mapWarning: {
    id: 'expozed.mapWarning',
    defaultMessage: 'Drag the pin to set your location.',
    description: 'Map Warning',
  },
  mapSuccess: {
    id: 'expozed.mapSuccess',
    defaultMessage: 'Great! Thank you!',
    description: 'Map Success',
  },
  photos: {
    id: 'expozed.photos',
    defaultMessage: 'Photos',
    description: 'Photos',
  },
  placeTitle: {
    id: 'expozed.placeTitle',
    defaultMessage: 'Name your place',
    description: 'Title',
  },
  titleLabel: {
    id: 'expozed.titleLabel',
    defaultMessage: 'Listing title',
    description: 'Title',
  },
  titleRequired: {
    id: 'expozed.titleRequired',
    defaultMessage: 'Oops! We need a title for your place.',
    description: 'Title is required',
  },
  description: {
    id: 'expozed.description',
    defaultMessage: 'Edit your description',
    description: 'Description',
  },
  descriptionRequired: {
    id: 'expozed.descriptionRequired',
    defaultMessage: 'Description is required',
    description: 'Description',
  },
  guestRequirementsTitle: {
    id: 'expozed.guestRequirementsTitle',
    defaultMessage: 'Review guest requirements',
    description: 'Guest Requirements Title',
  },
  guestRequirementsDescription: {
    id: 'expozed.guestRequirementsDescription',
    defaultMessage: 'Require all guests to submit the following before they can book:',
    description: 'Guest Requirements Description',
  },
  setHouseRules: {
    id: 'expozed.setHouseRules',
    defaultMessage: 'Set house rules for your guests',
    description: 'House Rules',
  },
  reviewGuestBookTitle: {
    id: 'expozed.reviewGuestBookTitle',
    defaultMessage: 'How guests book: Instantly',
    description: 'How guests book: Instantly',
  },
  reviewGuestBookDescription: {
    id: 'expozed.reviewGuestBookDescription',
    defaultMessage: 'Guests can book available days instantly as long as they:',
    description: 'Guests can book available',
  },
  reviewGuestBookNote: {
    id: 'expozed.reviewGuestBookNote',
    defaultMessage: 'Guests who don’t meet your requirements must send a reservation request.',
    description: 'Review Guests Note',
  },
  advanceNoticeTitle: {
    id: 'expozed.advanceNoticeTitle',
    defaultMessage: 'How much notice do you need before a guest arrives?',
    description: 'Advance Notice Title',
  },
  advanceNoticeCheckInTitle: {
    id: 'expozed.advanceNoticeCheckInTitle',
    defaultMessage: 'When can guests check in?',
    description: 'Advance Notice Check In Title',
  },
  advanceNoticeFrom: {
    id: 'expozed.advanceNoticeFrom',
    defaultMessage: 'From:',
    description: 'From',
  },
  advanceNoticeTo: {
    id: 'expozed.advanceNoticeTo',
    defaultMessage: 'To:',
    description: 'To',
  },
  advanceNoticeError: {
    id: 'expozed.advanceNoticeError',
    defaultMessage: 'From time should be earlier than To time',
    description: 'Error Message',
  },
  advanceNoticeInvalid: {
    id: 'expozed.advanceNoticeInvalid',
    defaultMessage: 'Invalid input value',
    description: 'Error Message',
  },
  MaxDaysNoticeTitle: {
    id: 'expozed.MaxDaysNoticeTitle',
    defaultMessage: 'How far in advance can guests book?',
    description: 'How far in advance can guests book?',
  },
  MinMaxNightsTitle: {
    id: 'expozed.MinMaxNightsTitle',
    defaultMessage: 'How long can guests stay?',
    description: 'How long can guests stay?',
  },
  calendar: {
    id: 'expozed.calendar',
    defaultMessage: 'Update your calendar',
    description: 'calendar title',
  },
  pricing: {
    id: 'expozed.pricing',
    defaultMessage: 'Base price',
    description: 'pricing title',
  },
  pricingDescription: {
    id: 'expozed.pricingDescription',
    defaultMessage: 'Your base price is your default nightly rate.',
    description: 'pricing description',
  },
  basePrice: {
    id: 'expozed.basePrice',
    defaultMessage: 'Base price',
    description: 'Base price',
  },
  basePriceLabel: {
    id: 'expozed.basePriceLabel',
    defaultMessage: 'Price per night',
    description: 'Base price Label',
  },
  basePriceInvalid: {
    id: 'expozed.basePriceInvalid',
    defaultMessage: 'Invalid Base Price, only numbers(eg: 25) are allowed',
    description: 'Base price Invalid',
  },
  basePriceRequired: {
    id: 'expozed.basePriceRequired',
    defaultMessage: 'Base Price is required',
    description: 'Base Price is required',
  },
  cleaningPriceInvalid: {
    id: 'expozed.cleaningPriceInvalid',
    defaultMessage: 'Invalid Cleaning Price, only numbers(eg: 25) are allowed',
    description: 'Cleaning price Invalid',
  },
  currency: {
    id: 'expozed.currency',
    defaultMessage: 'Currency',
    description: 'Currency',
  },
  discount: {
    id: 'expozed.discount',
    defaultMessage: 'Discounts',
    description: 'Discounts',
  },
  discountLabel: {
    id: 'expozed.discountLabel',
    defaultMessage: '% off',
    description: 'Discount Label',
  },
  discountWeekly: {
    id: 'expozed.discountWeekly',
    defaultMessage: 'Weekly discount',
    description: 'Weekly discount',
  },
  discountInvalid: {
    id: 'expozed.discountInvalid',
    defaultMessage: 'Invalid discount. The discount must be between 0% and 99%.',
    description: 'Invalid discount',
  },
  discountMonthly: {
    id: 'expozed.discountMonthly',
    defaultMessage: 'Monthly discount',
    description: 'Monthly discount',
  },
  summary: {
    id: 'expozed.summary',
    defaultMessage: 'Based on your settings, here’s what you could expect',
    description: 'Summary Title',
  },
  localLaws: {
    id: 'expozed.localLaws',
    defaultMessage: 'Your local laws and taxes',
    description: 'Local Laws',
  },
  setCoverPhoto: {
    id: 'expozed.setCoverPhoto',
    defaultMessage: 'Choose a photo for cover image',
    description: 'setCoverPhoto',
  },
  photosPlaceholder: {
    id: 'expozed.photosPlaceholder',
    defaultMessage: 'Click here to upload photos or drag them in',
    description: 'Photos Placeholder',
  },
  descriptionLabel: {
    id: 'expozed.descriptionLabel',
    defaultMessage: 'Describe the decor, light, what\'s nearby, etc...',
    description: 'Description Placeholder',
  },
  descriptionSubheading: {
    id: 'expozed.descriptionSubheading',
    defaultMessage: 'Summary',
    description: 'Description Subheading',
  },
  instantBookingTitle: {
    id: 'expozed.instantBookingTitle',
    defaultMessage: 'Increase your earnings with Instant Book',
    description: 'Instant booking',
  },
  instantBookingInfo: {
    id: 'expozed.instantBookingInfo',
    defaultMessage: 'Instant Book can give your listing an edge.Not only do guests prefer to book instantly, we’re promoting Instant Book listings in search results.',
    description: 'Instant booking',
  },
  whoCanBook: {
    id: 'expozed.whoCanBook',
    defaultMessage: 'Who can book instantly',
    description: 'Instant booking',
  },
  whoCanBookInfo: {
    id: 'expozed.whoCanBookInfo',
    defaultMessage: 'Choose who can book available days without requesting approval.',
    description: 'Instant booking',
  },
  whoCanBookInfo1: {
    id: 'expozed.whoCanBookInfo1',
    defaultMessage: 'Guests who meet your requirements and agree to your rules.',
    description: 'Instant booking',
  },
  whoCanBookInfo2: {
    id: 'expozed.whoCanBookInfo2',
    defaultMessage: 'Anyone else must send a reservation request.',
    description: 'Instant booking',
  },
  whoCanBookInfo3: {
    id: 'expozed.whoCanBookInfo3',
    defaultMessage: 'No one. All guests must send reservation requests.',
    description: 'Instant booking',
  },
  maxDaysTitle: {
    id: 'expozed.maxDaysTitle',
    defaultMessage: 'Booking Window',
    description: 'Booking Window',
  },
  datesDropDown: {
    id: 'expozed.datesDropDown',
    defaultMessage: 'Dates unavailable by default',
    description: 'Booking Dropdown',
  },
  datesOption1: {
    id: 'expozed.datesOption1',
    defaultMessage: '3 months into the future',
    description: 'Booking Dropdown',
  },
  datesOption2: {
    id: 'expozed.datesOption2',
    defaultMessage: '6 months into the future',
    description: 'Booking Dropdown',
  },
  datesOption3: {
    id: 'expozed.datesOption3',
    defaultMessage: '9 months into the future',
    description: 'Booking Dropdown',
  },
  datesOption4: {
    id: 'expozed.datesOption4',
    defaultMessage: '12 months into the future',
    description: 'Booking Dropdown',
  },
  datesOption5: {
    id: 'expozed.datesOption5',
    defaultMessage: 'All future dates',
    description: 'Booking Dropdown',
  },
  syncCalendars: {
    id: 'expozed.syncCalendars',
    defaultMessage: 'Sync calendars',
    description: 'Sync calendars',
  },
  tripLength: {
    id: 'expozed.tripLength',
    defaultMessage: 'Trip length',
    description: 'Trip length',
  },
  tripLengthError1: {
    id: 'expozed.tripLengthError1',
    defaultMessage: 'Minimum nights can\'t be higher than maximum nights',
    description: 'Trip length',
  },
  tabPlaceType: {
    id: 'expozed.tabPlaceType',
    defaultMessage: 'Place type',
    description: 'Tab bar',
  },
  tabPlaceType: {
    id: 'expozed.tabPlaceType',
    defaultMessage: 'Place type',
    description: 'Tab bar',
  },
  baths: {
    id: 'expozed.baths',
    defaultMessage: 'Baths',
    description: 'Tab bar',
  },
  setCover: {
    id: 'expozed.setCover',
    defaultMessage: 'Set Cover Photo',
    description: 'Set Cover Photo',
  },
  tabDescription: {
    id: 'expozed.tabDescription',
    defaultMessage: 'Description',
    description: 'Tab bar',
  },
  tabTitle: {
    id: 'expozed.tabTitle',
    defaultMessage: 'Title',
    description: 'Tab bar',
  },
  guestRequirements: {
    id: 'expozed.guestRequirements',
    defaultMessage: 'Guest Requirements',
    description: 'Tab bar',
  },
  reviewGuestBook: {
    id: 'expozed.reviewGuestBook',
    defaultMessage: 'Review GuestBook',
    description: 'Tab bar',
  },
  advanceNotice: {
    id: 'expozed.advanceNotice',
    defaultMessage: 'Advance Notice',
    description: 'Tab bar',
  },
  bookingWindow: {
    id: 'expozed.bookingWindow',
    defaultMessage: 'Booking window',
    description: 'Tab bar',
  },
  minMaxNights: {
    id: 'expozed.minMaxNights',
    defaultMessage: 'Min Max Nights',
    description: 'Tab bar',
  },
  tabCalendar: {
    id: 'expozed.tabCalendar',
    defaultMessage: 'Calendar',
    description: 'Tab bar',
  },
  tabPricing: {
    id: 'expozed.tabPricing',
    defaultMessage: 'Pricing',
    description: 'Tab bar',
  },
  tabDiscount: {
    id: 'expozed.tabDiscount',
    defaultMessage: 'Discount',
    description: 'Tab bar',
  },
  tabBooking: {
    id: 'expozed.tabBooking',
    defaultMessage: 'Booking',
    description: 'Tab bar',
  },
  tabLocalLaws: {
    id: 'expozed.tabLocalLaws',
    defaultMessage: 'Local Laws',
    description: 'Tab bar',
  },
  headerText: {
    id: 'expozed.headerText',
    defaultMessage: 'Step',
    description: 'Header Text',
  },
  readyToPublish: {
    id: 'expozed.readyToPublish',
    defaultMessage: 'Your listing is ready to be published!',
    description: 'Listing inde',
  },
  publishNow: {
    id: 'expozed.publishNow',
    defaultMessage: 'Publish Now',
    description: 'Listing index',
  },
  previewListing: {
    id: 'expozed.previewListing',
    defaultMessage: 'Preview Listing',
    description: 'Listing index',
  },
  listingPublished: {
    id: 'expozed.listingPublished',
    defaultMessage: 'Your listing is ready to be published!',
    description: 'Listing index',
  },
  unPublishNow: {
    id: 'expozed.unPublishNow',
    defaultMessage: 'UnPublish Now',
    description: 'Listing index',
  },
  signUpTitle: {
    id: 'expozed.signUpTitle',
    defaultMessage: 'New User Registration',
    description: 'Signup Title',
  },
  panelReservation: {
    id: 'expozed.panelReservation',
    defaultMessage: 'Reservations',
    description: 'Reservations',
  },
  transactions: {
    id: 'expozed.transactions',
    defaultMessage: 'Transactions',
    description: 'Transactions',
  },
  notFoundTitle: {
    id: 'expozed.notFoundTitle',
    defaultMessage: 'Uh-oh!',
    description: 'Not Found',
  },
  notFoundSubTitle: {
    id: 'expozed.notFoundSubTitle',
    defaultMessage: 'We can\'t seem to find the page you\'re looking for!',
    description: 'Not Found',
  },
  errorCode: {
    id: 'expozed.errorCode',
    defaultMessage: 'Error code: 404',
    description: 'Not Found',
  },
  linksTitle: {
    id: 'expozed.linksTitle',
    defaultMessage: 'Here are some helpful links instead:',
    description: 'Not Found',
  },
  hostingOn: {
    id: 'expozed.hostingOn',
    defaultMessage: 'Hosting on',
    description: 'Not Found',
  },
  pageError: {
    id: 'expozed.pageError',
    defaultMessage: 'Error',
    description: 'Page Error',
  },
  pageErrorInfo: {
    id: 'expozed.pageErrorInfo',
    defaultMessage: 'Sorry, a critical error occurred on this page.',
    description: 'Page Error',
  },
  messageStatus2: {
    id: 'expozed.messageStatus2',
    defaultMessage: 'Pre Approved',
    description: 'Message Status',
  },
  messageStatus3: {
    id: 'expozed.messageStatus3',
    defaultMessage: 'Declined',
    description: 'Message Status',
  },
  messageStatus4: {
    id: 'expozed.messageStatus4',
    defaultMessage: 'Approved',
    description: 'Message Status',
  },
  messageStatus5: {
    id: 'expozed.messageStatus5',
    defaultMessage: 'Pending',
    description: 'Message Status',
  },
  messageStatus6: {
    id: 'expozed.messageStatus6',
    defaultMessage: 'Cancelled by host',
    description: 'Message Status',
  },
  messageStatus7: {
    id: 'expozed.messageStatus7',
    defaultMessage: 'Cancelled by guest',
    description: 'Message Status',
  },
  messageStatus8: {
    id: 'expozed.messageStatus8',
    defaultMessage: 'Approved',
    description: 'Message Status',
  },
  messageStatus9: {
    id: 'expozed.messageStatus9',
    defaultMessage: 'Expired',
    description: 'Message Status',
  },
  messageStatus10: {
    id: 'expozed.messageStatus10',
    defaultMessage: 'Request to book',
    description: 'Message Status',
  },
  panelHeader1: {
    id: 'expozed.panelHeader1',
    defaultMessage: 'In progress',
    description: 'Panel Header',
  },
  panelHeader2: {
    id: 'expozed.panelHeader2',
    defaultMessage: 'Completed',
    description: 'Panel Header',
  },
  panelHeader3: {
    id: 'expozed.panelHeader3',
    defaultMessage: 'Approved',
    description: 'Panel Header',
  },
  messageStatus11: {
    id: 'expozed.messageStatus11',
    defaultMessage: 'Cancelled',
    description: 'Message Status',
  },
  messagesNew: {
    id: 'expozed.messagesNew',
    defaultMessage: 'New',
    description: 'New',
  },
  facebookLogin: {
    id: 'expozed.facebookLogin',
    defaultMessage: 'Log in with Facebook',
    description: 'Log in with Facebook',
  },
  googleLogin: {
    id: 'expozed.googleLogin',
    defaultMessage: 'Log in with Google',
    description: 'Log in with Google',
  },
  reviewToWrite: {
    id: 'expozed.reviewToWrite',
    defaultMessage: 'Reviews to Write',
    description: 'Reviews Panel',
  },
  cancellationNote: {
    id: 'expozed.cancellationNote',
    defaultMessage: 'A personal note can help',
    description: 'Cancellation Notes',
  },
  cancellationNoteForHost: {
    id: 'expozed.cancellationNoteForHost',
    defaultMessage: 'understand why you can\'t host them',
    description: 'Cancellation Notes',
  },
  saveAndContinue: {
    id: 'expozed.saveAndContinue',
    defaultMessage: 'Save & Continue',
    description: 'Save & Continue',
  },
  saveAndExit: {
    id: 'expozed.saveAndExit',
    defaultMessage: 'Save and Exit',
    description: 'Save and Exit',
  },
  reservationCancel: {
    id: 'expozed.reservationCancel',
    defaultMessage: 'The reservation will be cancelled immediately',
    description: 'Cancel your trip',
  },
  nonRefundable: {
    id: 'expozed.nonRefundable',
    defaultMessage: 'Non-Refundable',
    description: 'Cancel your trip',
  },
  refundable: {
    id: 'expozed.refundable',
    defaultMessage: 'Refundable',
    description: 'Cancel your trip',
  },
  refundCost: {
    id: 'expozed.refundCost',
    defaultMessage: 'You will be refunded the above cost.',
    description: 'Cancel your trip',
  },
  keepReservation: {
    id: 'expozed.keepReservation',
    defaultMessage: 'Keep reservation',
    description: 'Keep reservation',
  },
  cancelYourReservation: {
    id: 'expozed.cancelYourReservation',
    defaultMessage: 'Cancel your reservation',
    description: 'Cancel your reservation',
  },
  cleaningMinusServiceFee: {
    id: 'expozed.cleaningMinusServiceFee',
    defaultMessage: 'cleaning fees, minus service fees.',
    description: 'Cleaning fee and service fee',
  },
  earnings: {
    id: 'expozed.earnings',
    defaultMessage: 'Earnings',
    description: 'Earnings',
  },
  cleaningPlusServiceFee: {
    id: 'expozed.cleaningPlusServiceFee',
    defaultMessage: 'plus cleaning fees, minus host service fees.',
    description: 'plus cleaning fees, plus host service fees.',
  },
  willBeRefund: {
    id: 'expozed.willBeRefund',
    defaultMessage: 'will be refunded the',
    description: 'will be refunded the',
  },
  reservationCost: {
    id: 'expozed.reservationCost',
    defaultMessage: 'reservation cost.',
    description: 'Reservation cost',
  },
  cancelYourTrip: {
    id: 'expozed.cancelYourTrip',
    defaultMessage: 'Cancel your trip',
    description: 'Cancel your Trip',
  },
  consider: {
    id: 'expozed.consider',
    defaultMessage: 'Consider',
    description: 'Consider',
  },
  tripBeforeCanceling: {
    id: 'expozed.tripBeforeCanceling',
    defaultMessage: 'trip before canceling',
    description: 'Trip before canceling',
  },
  cancellingInfo: {
    id: 'expozed.cancellingInfo',
    defaultMessage: 'Cancelling a guest\'s reservation can disrupt their plans and have serious implications on their trip.',
    description: 'Trip before canceling',
  },
  started: {
    id: 'expozed.started',
    defaultMessage: 'Started',
    description: 'Started',
  },
  startIn: {
    id: 'expozed.startIn',
    defaultMessage: 'Starts in',
    description: 'Starts in',
  },
  travelingWith: {
    id: 'expozed.travelingWith',
    defaultMessage: 'Traveling With',
    description: 'Traveling With',
  },
  needToCancel: {
    id: 'expozed.needToCancel',
    defaultMessage: 'why you need to cancel',
    description: 'why you need to cancel',
  },
  stayingFor: {
    id: 'expozed.stayingFor',
    defaultMessage: 'Staying for',
    description: 'Staying for',
  },
  propertyLocated: {
    id: 'expozed.propertyLocated',
    defaultMessage: 'property is located in',
    description: 'Property is located in',
  },
  responseFrom: {
    id: 'expozed.responseFrom',
    defaultMessage: 'Response from',
    description: 'Response from',
  },
  savingButton: {
    id: 'expozed.savingButton',
    defaultMessage: 'Saving',
    description: 'Saving Button',
  },
  night: {
    id: 'expozed.night',
    defaultMessage: 'night',
    description: 'Bill Details',
  },
  minimumStay: {
    id: 'expozed.minimumStay',
    defaultMessage: 'minimum stay',
    description: 'Minimum stay',
  },
  minimumNightStay: {
    id: 'expozed.minimumNightStay',
    defaultMessage: 'Minimum stay is',
    description: 'Minimum stay',
  },
  maximumNightStay: {
    id: 'expozed.maximumNightStay',
    defaultMessage: 'maximum stay',
    description: 'Maximum stay',
  },
  review: {
    id: 'expozed.review',
    defaultMessage: 'Review',
    description: 'Review',
  },
  verifications: {
    id: 'expozed.verifications',
    defaultMessage: 'Verifications',
    description: 'Verifications',
  },
  verification: {
    id: 'expozed.verification',
    defaultMessage: 'Verification',
    description: 'Verification',
  },
  guestCapcity: {
    id: 'expozed.guestCapcity',
    defaultMessage: 'guest',
    description: 'Guest',
  },
  guestsCapcity: {
    id: 'expozed.guestsCapcity',
    defaultMessage: 'guests',
    description: 'Guests',
  },
  monthlyDiscount: {
    id: 'expozed.monthlyDiscount',
    defaultMessage: 'monthly price discount',
    description: 'Monthly Discount',
  },
  weeklyDiscount: {
    id: 'expozed.weeklyDiscount',
    defaultMessage: 'weekly price discount',
    description: 'Weekly Discount',
  },
  flexibleCheckIn: {
    id: 'expozed.flexibleCheckIn',
    defaultMessage: 'Flexible check in time',
    description: 'Flexible check in time',
  },
  cancellationNoteForGuest: {
    id: 'expozed.cancellationNoteForGuest',
    defaultMessage: 'understand why you want to cancel your reservation',
    description: 'Cancellation notes fot guest',
  },
  howManyday: {
    id: 'expozed.howManyday',
    defaultMessage: 'day',
    description: 'day',
  },
  howManydays: {
    id: 'expozed.howManydays',
    defaultMessage: 'days',
    description: 'days',
  },
  howManyGuest: {
    id: 'expozed.howManyGuest',
    defaultMessage: 'Guests',
    description: 'Guest',
  },
  reviewFor: {
    id: 'expozed.reviewFor',
    defaultMessage: 'Review for',
    description: 'Review for',
  },
  your: {
    id: 'expozed.your',
    defaultMessage: 'Your',
    description: 'Your',
  },
  chooseCancellationPolicy: {
    id: 'expozed.chooseCancellationPolicy',
    defaultMessage: 'Cancellation Policy',
    description: 'Cancellation Policy',
  },
  pendingPayouts: {
    id: 'expozed.pendingPayouts',
    defaultMessage: 'Pending Payouts',
    description: 'Pending Payouts',
  },
  allPayoutMethod: {
    id: 'expozed.allPayoutMethod',
    defaultMessage: 'All payout methods',
    description: 'All payout methods',
  },
  inboxCompleted: {
    id: 'expozed.inboxCompleted',
    defaultMessage: 'Completed',
    description: 'Message Status - Inbox Item',
  },
  loginConfirmation: {
    id: 'expozed.loginConfirmation',
    defaultMessage: 'Sorry, you must login to confirm your email. Please login and try clicking the link from your email again!',
    description: 'Login confirmation',
  },
  upcomingReservations: {
    id: 'expozed.upcomingReservations',
    defaultMessage: 'Upcoming Reservations',
    description: 'Upcoming Reservations',
  },
  previousReservations: {
    id: 'expozed.previousReservations',
    defaultMessage: 'Previous Reservations',
    description: 'Previous Reservations',
  },
  upcomingTrips: {
    id: 'expozed.upcomingTrips',
    defaultMessage: 'Upcoming Trips',
    description: 'Upcoming Trips',
  },
  previousTrips: {
    id: 'expozed.previousTrips',
    defaultMessage: 'Previous Trips',
    description: 'Previous Trips',
  },
  noUpcomingReservation: {
    id: 'expozed.noUpcomingReservation',
    defaultMessage: 'You don\'t have any upcoming reservations!',
    description: 'noUpcomingReservation',
  },
  noPreviousReservation: {
    id: 'expozed.noPreviousReservation',
    defaultMessage: 'You don\'t have any previous reservations!',
    description: 'noPreviousReservation',
  },
  noUpcomingTrips: {
    id: 'expozed.noUpcomingTrips',
    defaultMessage: 'You don\'t have any upcoming trips!',
    description: 'noUpcomingTrips',
  },
  noPreviousTrips: {
    id: 'expozed.noPreviousTrips',
    defaultMessage: 'You don\'t have any previous trips!',
    description: 'noPreviousTrips',
  },
  payNow: {
    id: 'expozed.paynow',
    defaultMessage: 'Pay now',
    description: 'Pay now',
  },
  creditCard: {
    id: 'expozed.creditCard',
    defaultMessage: 'Credit Card',
    description: 'Credit Card',
  },
  payPal: {
    id: 'expozed.payPal',
    defaultMessage: 'Pay Pal',
    description: 'payPal',
  },
  fullName: {
    id: 'expozed.fullName',
    defaultMessage: 'Full Name',
    description: 'fullName',
  },
  cardNumber: {
    id: 'expozed.cardNumber',
    defaultMessage: 'Credit Card Number',
    description: 'cardNumber',
  },
  cvv: {
    id: 'expozed.cvv',
    defaultMessage: 'CVV',
    description: 'cvv',
  },
  expiryDate: {
    id: 'expozed.expiryDate',
    defaultMessage: 'Month',
    description: 'expiryDate',
  },
  expiryYear: {
    id: 'expozed.expiryYear',
    defaultMessage: 'Year',
    description: 'expiryYear',
  },
  cardExpires: {
    id: 'expozed.Expires',
    defaultMessage: 'Expires',
    description: 'Expires',
  },
  required: {
    id: 'expozed.required',
    defaultMessage: '*Required',
    description: '*Required',
  },
  invalid: {
    id: 'expozed.invalid',
    defaultMessage: '*Invalid',
    description: '*Invalid',
  },
  payoutFirstName: {
    id: 'expozed.payoutFirstName',
    defaultMessage: 'Account holder first name',
    description: 'payoutFirstName',
  },
  payoutLastName: {
    id: 'expozed.payoutLastName',
    defaultMessage: 'Account holder last name',
    description: 'payoutLastName',
  },
  payoutRouting: {
    id: 'expozed.payoutRouting',
    defaultMessage: 'Routing number',
    description: 'payoutRouting',
  },
  accountNumber: {
    id: 'expozed.accountNumber',
    defaultMessage: 'Account number',
    description: 'accountNumber',
  },
  confirmAccountNumber: {
    id: 'expozed.confirmAccountNumber',
    defaultMessage: 'Confirm account number',
    description: 'confirmAccountNumber',
  },
  ssn4Digits: {
    id: 'expozed.ssn4Digits',
    defaultMessage: 'SSN last 4 digits',
    description: 'ssn4Digits',
  },
  payoutFirstNameRequired: {
    id: 'expozed.payoutFirstNameRequired',
    defaultMessage: 'First name is required',
    description: 'payoutFirstNameRequired',
  },
  payoutLastNameRequired: {
    id: 'expozed.payoutLastNameRequired',
    defaultMessage: 'Last name is required',
    description: 'payoutLastNameRequired',
  },
  payoutRoutingRequired: {
    id: 'expozed.payoutRoutingRequired',
    defaultMessage: 'Routing number is required',
    description: 'payoutRoutingRequired',
  },
  payoutRoutingInvalid: {
    id: 'expozed.payoutRoutingInvalid',
    defaultMessage: 'Invalid routing number',
    description: 'payoutRoutingInvalid',
  },
  accountNumberRequired: {
    id: 'expozed.accountNumberRequired',
    defaultMessage: 'Account number is required',
    description: 'accountNumberRequired',
  },
  accountNumberInvalid: {
    id: 'expozed.accountNumberInvalid',
    defaultMessage: 'Invalid account number',
    description: 'accountNumberInvalid',
  },
  confirmAccountNumberRequired: {
    id: 'expozed.confirmAccountNumberRequired',
    defaultMessage: 'Confirm account number is required',
    description: 'confirmAccountNumberRequired',
  },
  confirmAccountNumberInvalid: {
    id: 'expozed.confirmAccountNumberInvalid',
    defaultMessage: 'Invalid confirm account number',
    description: 'confirmAccountNumberInvalid',
  },
  confirmAccountNumberMismatch: {
    id: 'expozed.confirmAccountNumberMismatch',
    defaultMessage: 'Account number mismatch',
    description: 'confirmAccountNumberMismatch',
  },
  ssn4DigitsRequired: {
    id: 'expozed.ssn4DigitsRequired',
    defaultMessage: 'SSN number is required',
    description: 'ssn4DigitsRequired',
  },
  ssn4DigitsInvalid: {
    id: 'expozed.ssn4DigitsInvalid',
    defaultMessage: 'Invalid SSN number',
    description: 'ssn4DigitsInvalid',
  },
  verifiedBy: {
    id: 'expozed.verifiedBy',
    defaultMessage: 'Verified By',
    description: 'verifiedBy',
  },
  saved: {
    id: 'expozed.saved',
    defaultMessage: 'Saved',
    description: 'saved',
  },
  wishList: {
    id: 'expozed.wishList',
    defaultMessage: 'Wish List',
    description: 'wishList',
  },
  wishLists: {
    id: 'expozed.wishLists',
    defaultMessage: 'Wish Lists',
    description: 'wishLists',
  },
  createWishList: {
    id: 'expozed.createWishList',
    defaultMessage: 'Create Wish List',
    description: 'createWishList',
  },
  list: {
    id: 'expozed.list',
    defaultMessage: 'List',
    description: 'list',
  },
  lists: {
    id: 'expozed.lists',
    defaultMessage: 'Lists',
    description: 'lists',
  },
  yourLists: {
    id: 'expozed.yourLists',
    defaultMessage: 'Your lists',
    description: 'yourLists',
  },
  homes: {
    id: 'expozed.homes',
    defaultMessage: 'Homes',
    description: 'homes',
  },
  nameRequired: {
    id: 'expozed.nameRequired',
    defaultMessage: 'Name is required',
    description: 'Name Required',
  },
  privacySettings: {
    id: 'expozed.privacySettings',
    defaultMessage: 'Privacy Settings',
    description: 'Privacy Settings',
  },
  wishListAdded: {
    id: 'expozed.wishListAdded',
    defaultMessage: 'Wish list added successfully.',
    description: 'Wish list added',
  },
  wishListUpdated: {
    id: 'expozed.wishListUpdated',
    defaultMessage: 'Wish list updated successfully.',
    description: 'Wish list updated',
  },
  editWishList: {
    id: 'expozed.editWishList',
    defaultMessage: 'Edit Wish List',
    description: 'editWishList',
  },
  yourHomes: {
    id: 'expozed.yourHomes',
    defaultMessage: 'Your Homes',
    description: 'hoyourHomesmes',
  },
  deleteWishList: {
    id: 'expozed.deleteWishList',
    defaultMessage: 'Delete this list',
    description: 'deleteWishList',
  },
  noWishlists: {
    id: 'expozed.noWishlists',
    defaultMessage: 'Sorry, you don\'t have any homes wishlisted.',
    description: 'noWishlists',
  },
  public: {
    id: 'expozed.public',
    defaultMessage: 'Public',
    description: 'public',
  },
  private: {
    id: 'expozed.private',
    defaultMessage: 'Private',
    description: 'private',
  },
  goToAllLists: {
    id: 'expozed.goToAllLists',
    defaultMessage: 'Go to All Lists',
    description: 'Go to All Lists',
  },
  noWishlistsHomes: {
    id: 'expozed.noWishlistsHomes',
    defaultMessage: 'Sorry, You don\'t have any wishlist homes!',
    description: 'noWishlistsHomes',
  },
  areYouSureDeleteWishList: {
    id: 'expozed.areYouSureDeleteWishList',
    defaultMessage: 'Are you sure you want to delete this?',
    description: 'areYouSureDeleteWishList',
  },
  confirmDelete: {
    id: 'expozed.confirmDelete',
    defaultMessage: 'Confirm Delete',
    description: 'confirmDelete',
  },
  similarListings: {
    id: 'expozed.similarListings',
    defaultMessage: 'Similar Listings',
    description: 'similarListings',
  },
  overview: {
    id: 'expozed.overview',
    defaultMessage: 'Overview',
    description: 'Overview',
  },
  theHost: {
    id: 'expozed.theHost',
    defaultMessage: 'The Host',
    description: 'The Host',
  },



//ID verification

  documentverification: {
    id: 'expozed.documentverification',
    defaultMessage: 'Document Verification',
    description: 'documentverification',
  },
  documentverified: {
    id: 'expozed.documentverified',
    defaultMessage: 'Documents verified',
    description: 'Documents verified',
  },

  verificationdocument: {
    id: 'expozed.verificationdocument',
    defaultMessage: 'Documents Verified',
    description: 'verificationdocument',
  },

  documentverificationDetails: {
    id: 'expozed.documentverificationDetails',
    defaultMessage: 'Your document have been verified',
    description: 'documentverificationDetails',
  },

  documentApproveRejectMessage: {
    id: 'expozed.documentApproveRejectMessage',
    defaultMessage: 'Type Your Message',
    description: 'documentApproveRejectMessage',
  },
  documentApprove: {
    id: 'expozed.documentApprove',
    defaultMessage: 'Approve',
    description: 'documentApprove',
  },
  documentReject: {
    id: 'expozed.documentReject',
    defaultMessage: 'Reject',
    description: 'documentReject',
  },

  documentAppRejRequried: {
    id: 'expozed.documentAppRejRequried',
    defaultMessage: 'Please Fill Required',
    description: 'documentAppRejRequried',
  },
  documentUploadPlaceholder: {
    id: 'expozed.documentUploadPlaceholder',
    defaultMessage: 'Click here to upload document or drag them in',
    description: 'Document Upload Placeholder',
  },
  documentVerificationInfo: {
    id: 'expozed.documentVerificationInfo',
    defaultMessage: 'Please upload your documents for ID verification. Eg: Passport, Driving License',
    description: 'Document Verification Info',
  },


   //KYC verification

  kycverification: {
    id: 'expozed.kycverification',
    defaultMessage: 'kyc Verification',
    description: 'kycverification',
  },
  kycverificationText: {
    id: 'expozed.kycverificationText',
    defaultMessage: 'kyc Verification Text',
    description: 'kycverification Text',
  },
  kycverified: {
    id: 'expozed.kycverified',
    defaultMessage: 'kycs verified',
    description: 'kycs verified',
  },

  verificationkyc: {
    id: 'expozed.verificationkyc',
    defaultMessage: 'kycs Verified',
    description: 'verificationkyc',
  },

  kycverificationDetails: {
    id: 'expozed.kycverificationDetails',
    defaultMessage: 'Your kyc have been verified',
    description: 'kycverificationDetails',
  },

  kycApproveRejectMessage: {
    id: 'expozed.kycApproveRejectMessage',
    defaultMessage: 'Type Your Message',
    description: 'kycApproveRejectMessage',
  },
  kycApprove: {
    id: 'expozed.kycApprove',
    defaultMessage: 'Approve',
    description: 'kycApprove',
  },
  kycReject: {
    id: 'expozed.kycReject',
    defaultMessage: 'Reject',
    description: 'kycReject',
  },

  kycAppRejRequried: {
    id: 'expozed.kycAppRejRequried',
    defaultMessage: 'Please Fill Required',
    description: 'kycAppRejRequried',
  },
  kycUploadPlaceholder: {
    id: 'expozed.kycUploadPlaceholder',
    defaultMessage: 'Click here to upload kyc or drag them in',
    description: 'kyc Upload Placeholder',
  },
  kycVerificationInfo: {
    id: 'expozed.kycVerificationInfo',
    defaultMessage: 'Please upload your kycs for ID verification. Eg: Passport, Driving License',
    description: 'kyc Verification Info',
  },


  
  
  searchAsIMove: {
    id: 'expozed.searchAsIMove',
    defaultMessage: 'Search as I move the map',
    description: 'Search as I move the map',
  },
  blankSpace: {
    id: 'expozed.blankSpace',
    defaultMessage: 'Input is Blank',
    description: 'blankSpace',
  },
  ContactMessage: {
    id: 'expozed.ContactMessage',
    defaultMessage: 'Message',
    description: 'ContactMessage',
  },
  contactForm: {
    id: 'expozed.contactForm',
    defaultMessage: 'Contact Us',
    description: 'contactForm',
  },
  contact: {
    id: 'expozed.contact',
    defaultMessage: 'Contact',
    description: 'contactMenu',
  },
  Nameincontact: {
    id: 'expozed.Nameincontact',
    defaultMessage: 'Name',
    description: 'Nameincontact',
  },
  recaptchaRequired: {
    id: 'expozed.recaptchaRequired',
    defaultMessage: 'Recaptcha Required',
    description: 'recaptchaRequired',
  },
  sendmail: {
    id: 'expozed.sendmail',
    defaultMessage: 'Send',
    description: 'Send',
  },
  nameYourList: {
    id: 'expozed.nameYourList',
    defaultMessage: 'Name your list',
    description: 'List Name',
  },
  createButton: {
    id: 'expozed.createButton',
    defaultMessage: 'Create',
    description: 'Wish list button',
  },
  flexibleCheckOut: {
    id: 'expozed.flexibleCheckOut',
    defaultMessage: 'Flexible check out time',
    description: 'Flexible check out time',
  },
  helpFirstTitle: {
    id: 'expozed.helpFirstTitle',
    defaultMessage: 'Create your listing',
    description: 'Title',
  },
  helpSecondTitle: {
    id: 'expozed.helpSecondTitle',
    defaultMessage: 'Welcome your guests',
    description: 'Title',
  },
  helpThirdTitle: {
    id: 'expozed.helpThirdTitle',
    defaultMessage: 'Getting paid safely',
    description: 'Title',
  },

  helpFirstDesc1: {
    id: 'expozed.helpFirstDesc1',
    defaultMessage: 'Simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s.',
    description: 'Description',
  },

  helpFirstDesc2: {
    id: 'expozed.helpFirstDesc2',
    defaultMessage: 'Maecenas non scelerisque purus, congue cursus arcu. Donec vel dapibus mi. Mauris maximus posuere placerat. Sed et libero eu nibh tristique mollis a eget lectus',
    description: 'Description',
  },
  helpSecondDesc1: {
    id: 'expozed.helpSecondDesc1',
    defaultMessage: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
    description: 'Description',
  },
  helpSecondDesc2: {
    id: 'expozed.helpSecondDesc2',
    defaultMessage: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for lorem ipsum will uncover many web sites still in their infancy. ',
    description: 'Description',
  },

  helpSecondDesc3: {
    id: 'expozed.helpSecondDesc3',
    defaultMessage: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    description: 'Description',
  },
  helpThirdDesc1: {
    id: 'expozed.helpThirdDesc1',
    defaultMessage: ' Morbi pellentesque venenatis felis sed convallis. Nulla varius, nibh vitae placerat tempus, mauris sem elementum ipsum. ',
    description: 'Description',
  },
  helpThirdDesc2: {
    id: 'expozed.helpThirdDesc2',
    defaultMessage: 'Fusce quis varius nulla. Nullam nisi nisi, suscipit ut magna quis, feugiat porta nibh. ',
    description: 'Description',
  },
  helpThirdDesc3: {
    id: 'expozed.helpThirdDesc3',
    defaultMessage: 'Pellentesque sagittis vehicula sem quis luctus. Proin sodales magna in lorem hendrerit aliquam. Integer eu varius orci.',
    description: 'Description',
  },
  processFlowHeading: {
    id: 'expozed.processFlowHeading',
    defaultMessage: 'Earn Extra Money and Become a Host with Expozed',
    description: 'Process Flow Heading',
  },
  processFlowSubHeading: {
    id: 'expozed.processFlowSubHeading',
    defaultMessage: 'Explorez le site à la recherche du photographe idéal et profitez des bons moments en toute sereinité',
    description: 'Process Flow Heading',
  },
  stepOneHeading: {
    id: 'expozed.stepOneHeading',
    defaultMessage: 'Why host with Expozed?',
    description: 'Step 1',
  },
  stepTwoHeading: {
    id: 'expozed.stepTwoHeading',
    defaultMessage: 'Stay in Control',
    description: 'Step 2',
  },
  stepThreeHeading: {
    id: 'expozed.stepThreeHeading',
    defaultMessage: 'Stay Confident',
    description: 'Step 3',
  },
  stepOneFlow: {
    id: 'expozed.stepOneFlow',
    defaultMessage: 'Share your villa, condo or apartment and earn yourself an extra income. With over 12 years of experience, we make it simple and safe to reach guests that are looking for fun and unique Places to stay across Thailand and Bali.',
    description: 'Step 1',
  },
  stepTwoFlow: {
    id: 'expozed.stepTwoFlow',
    defaultMessage: 'Stay in control with Expozed. You have full control of your availability, rates and rules. You can, block dates, set check-in times and manage your own communications directly with your guests through the system.',
    description: 'Step 2',
  },
  stepThreeFlow: {
    id: 'expozed.stepThreeFlow',
    defaultMessage: 'We offer all the right tools to allow you to host in confidence. From a flexible booking system through to a secure payment system. Stay connected and confident with the latest technology.',
    description: 'Step 3',
  },
  anonymousMessage: {
    id: 'expozed.anonymousMessage',
    defaultMessage: 'Do you want to report this User?',
    description: 'Report User',
  },
  reportUserInfo: {
    id: 'expozed.reportUserInfo',
    defaultMessage: 'If so, please choose one of the following reasons.',
    description: 'Report User',
  },
  reportContent1: {
    id: 'expozed.reportContent1',
    defaultMessage: 'This profile should not be on',
    description: 'Report User',
  },
  reportContent2: {
    id: 'expozed.reportContent2',
    defaultMessage: 'Attempt to share contact information',
    description: 'Report User',
  },
  close: {
    id: 'expozed.close',
    defaultMessage: 'Close',
    description: 'Report User',
  },
  reportContent3: {
    id: 'expozed.reportContent3',
    defaultMessage: 'Inappropriate content of spam',
    description: 'Report User',
  },
  thankyouInfo1: {
    id: 'expozed.thankyouInfo1',
    defaultMessage: 'Thanks for taking the time to report this user. These reports help make better for everyone, so we take them seriously. We will reach out if we have questions about your report.',
    description: 'Report User',
  },
  thankyouTitle: {
    id: 'expozed.thankyouTitle',
    defaultMessage: 'Thank You',
    description: 'Report User',
  },
  messageHistroyLabel: {
    id: 'expozed.messageHistroyLabel',
    defaultMessage: 'View',
    description: 'Report User',
  },
  titleRequiredLabel: {
    id: 'expozed.titleRequiredLabel',
    defaultMessage: 'Message History',
    description: 'Report User',
  },
  topBannerTitle: {
    id: 'expozed.topBannerTitle',
    defaultMessage: 'It\'s simple to become a Expozed host',
    description: 'Report User',
  },
  footerTerms: {
    id: 'expozed.footerTerms',
    defaultMessage: 'Terms, Privacy, Currency & More',
    description: 'Footer Button',
  },
  footerClose: {
    id: 'expozed.footerClose',
    defaultMessage: 'Close',
    description: 'Footer Button',
  },
  myHostSpaces: {
    id: 'expozed.myHostSpaces',
    defaultMessage: 'Spaces',
    description: 'Menu Item'
  },
  mySpace: {
    id: 'expozed.mySpace',
    defaultMessage: 'Space',
    description: 'Menu Item'
  },
  clear: {
    id: 'expozed.clear',
    defaultMessage: 'Clear',
    description: 'clear',
  },
  apply: {
    id: 'expozed.apply',
    defaultMessage: 'Apply',
    description: 'apply',
  },
  homeType: {
    id: 'expozed.homeType',
    defaultMessage: 'Home type',
    description: 'homeType',
  },
  price: {
    id: 'expozed.price',
    defaultMessage: 'Price',
    description: 'price',
  },
  moreFilters: {
    id: 'expozed.moreFilters',
    defaultMessage: 'More filters',
    description: 'moreFilters',
  },
  showAmenities: {
    id: 'expozed.showAmenities',
    defaultMessage: 'Show all amenities',
    description: 'Toggle Button',
  },
  closeAmenities: {
    id: 'expozed.closeAmenities',
    defaultMessage: 'Close all amenities',
    description: 'Toggle Button',
  },
  showMore: {
    id: 'expozed.showMore',
    defaultMessage: 'Show More',
    description: 'Toggle Button',
  },
  showLess: {
    id: 'expozed.showLess',
    defaultMessage: 'Show Less',
    description: 'Toggle Button',
  },
  showAll: {
    id: 'expozed.showAll',
    defaultMessage: 'Show all',
    description: 'Toggle Button',
  },
  closeSafetyFeatures: {
    id: 'expozed.closeSafetyFeatures',
    defaultMessage: 'Close safety features',
    description: 'Toggle Button',
  },
  closeSharedSpaces: {
    id: 'expozed.closeSharedSpaces',
    defaultMessage: 'Close Shared Spaces',
    description: 'Toggle Button',
  },
  spacesInfo: {
    id: 'expozed.spacesInfo',
    defaultMessage: 'Spaces',
    description: 'Spaces',
  },
  neighbourHood: {
    id: 'expozed.neighbourHood',
    defaultMessage: 'Neighbourhood',
    description: 'Become Host Form',
  },
  readMoreAboutSpaces: {
    id: 'expozed.readMoreAboutSpaces',
    defaultMessage: 'Read more about the space',
    description: 'View Listing',
  },
  hideButton: {
    id: 'expozed.hideButton',
    defaultMessage: 'Hide',
    description: 'View Listing',
  },
  showNeighbourHood: {
    id: 'expozed.showNeighbourHood',
    defaultMessage: 'Show NeighbourHood',
    description: 'Toggle Button',
  },
  gettingAround: {
    id: 'expozed.gettingAround',
    defaultMessage: 'Getting Around',
    description: 'View Listing',
  },
  bookNow: {
    id: 'expozed.bookNow',
    defaultMessage: 'Book Now',
    description: 'Booking button',
  },
  bedTypes: {
    id: 'expozed.bedTypes',
    defaultMessage: 'Bed Types',
    description: 'Bed Types',
  },
  contactAdmin: {
    id: 'expozed.contactAdmin',
    defaultMessage: ' contact us.',
    description: 'Contact Admin',
  },
  roomsAndBeds: {
    id: 'expozed.roomsAndBeds',
    defaultMessage: 'Rooms and Beds',
    description: 'Rooms and Beds',
  },
  showAllFacilities: {
    id: 'expozed.showAllFacilities',
    defaultMessage: 'Show all facilities',
    description: 'Show all facilities text',
  },
  closeFacilities: {
    id: 'expozed.closeFacilities',
    defaultMessage: 'Close all facilities',
    description: 'Close facilities text',
  },
  showAllHouseRules: {
    id: 'expozed.showAllHouseRules',
    defaultMessage: 'Show all house rules',
    description: 'Show all house rules text',
  },
  closeHouseRules: {
    id: 'expozed.closeHouseRules',
    defaultMessage: 'Close all house rules',
    description: 'Close house rules text',
  },
  chooseACountry: {
    id: 'expozed.chooseACountry',
    defaultMessage: 'Choose a country',
    description: 'Choose a country',
  },
  addPhoneNumber: {
    id: 'expozed.addPhoneNumber',
    defaultMessage: 'Add phone number',
    description: 'Add phone number',
  },
  noPhoneNumberEntered: {
    id: 'expozed.noPhoneNumberEntered',
    "description": "No phone number entered.",
    "defaultMessage": "No phone number entered.",
  },
  addAPhoneNumber: {
    id: 'expozed.addAPhoneNumber',
    defaultMessage: 'Add a phone number',
    description: 'Add a phone number',
  },
  verifyViaSms: {
    id: 'expozed.verifyViaSms',
    defaultMessage: 'Verify via SMS',
    description: 'Verify via SMS',
  },
  mobileNumberRequired: {
    id: 'expozed.mobileNumberRequired',
    defaultMessage: 'Please enter a phone number.',
    description: 'Please enter a phone number.',
  },
  weHaveSentVerificationCode: {
    id: 'expozed.weHaveSentVerificationCode',
    defaultMessage: 'We sent a verification code to',
    description: 'We sent a verification code to',
  },
  verificationCodeLabel: {
    id: 'expozed.verificationCodeLabel',
    defaultMessage: 'Please enter the 4-digit code',
    description: 'Please enter the 4-digit code',
  },
  verificationCodeRequired: {
    id: 'expozed.verificationCodeRequired',
    defaultMessage: 'Please enter a verification code.',
    description: 'Please enter a verification code.',
  },
  seeAll: {
    id: 'expozed.seeAll',
    defaultMessage: 'See All',
    description: 'seeAll',
  },
  locationRequired: {
    id: 'expozed.locationRequired',
    defaultMessage: 'Location is required',
    description: 'Location is required',
  },
  locationAddressRequired: {
    id: 'expozed.locationAddressRequired',
    defaultMessage: 'Location Address is required',
    description: 'Location Address is required',
  },
  listNotFoundTitle: {
    id: 'expozed.listNotFoundTitle',
    defaultMessage: 'It looks like this listing may deleted or unpublished.',
    description: 'Not Found',
  },
  userDeleted: {
    id: 'expozed.userDeleted',
    defaultMessage: 'You are deleted by admin.',
    description: 'You are deleted user',
  },
  cancelInfoBooking: {
    id: 'expozed.cancelInfoBooking',
    defaultMessage: 'Most hosts respond within 24 hours.',
    description: 'View message',
  },
  cookiesDisclaimer: {
    id: 'expozed.cookiesDisclaimer',
    defaultMessage: 'uses cookies to understand how you use our site and to improve your experience. By using our site, you accept our use of cookies. To learn more, go to our',
    description: 'extraGuestIncluded'
  },
  gotIt: {
    id: 'expozed.gotIt',
    defaultMessage: 'GOT IT',
    description: ' cookies Disclaimer Button'
  },
  step1HeadingNew: {
    id: 'expozed.step1HeadingNew',
    defaultMessage: 'STEP 1',
    description: 'STEP 2 Heading',
  },
  Maximumupload: {
    id: 'expozed.Maximumupload',
    defaultMessage: 'Maximum upload size:1MB',
    description: 'Photos Upload',
  },
  cookiePolicy: {
    id: 'expozed.cookiePolicy',
    defaultMessage: 'Cookie policy',
    description: ' cookies Disclaimer Link'
  },
  blockDates: {
    id: 'expozed.blockedDates',
    defaultMessage: 'Block dates',
    description: 'Listing Step3',
  },
  deSelect: {
    id: 'expozed.deSelect',
    defaultMessage: 'Cancel',
    description: 'Cancel deSelect button',
  },
  selectedDatesSuccess: {
    id: 'expozed.selectedDatesSuccess',
    defaultMessage: 'Your calendar has been updated successfully',
    description: 'Your calendar has been updated successfully.'
  },
  selectedDatesError: {
    id: 'expozed.selectedDatesError',
    defaultMessage: 'Something went wrong, please try again.',
    description: 'Something went wrong, please try again.'
  },
  selectedDates: {
    id: 'expozed.selectedDates',
    defaultMessage: 'Selected dates',
    description: 'Selected dates'
  },
  makeDateAvailable: {
    id: 'expozed.makeDateAvailable',
    defaultMessage: 'Special Price',
    description: 'Listing Step3'
  },
  sessionPrice: {
    id: 'expozed.sessionPrice',
    defaultMessage: 'Special Price',
    description: 'sessionPrice'
  },
  selectedDatesBlocked: {
    id: 'expozed.selectedDatesBlocked',
    defaultMessage: 'Selected dates will be blocked.',
    description: 'Selected dates will be blocked.'
  },
  availablilityterm: {
    id: 'expozed.availablilityterm',
    defaultMessage: 'Availability term',
    description: 'Availability term',
  },
  contactFormInformation: {
    id: 'expozed.contactFormInformation',
    defaultMessage: ' Contact & Support',
    description: 'contactForm',
  },
  contactFormEmail: {
    id: 'expozed.contactFormEmail',
    defaultMessage: 'Email Us',
    description: 'contactForm',
  },
  contactFormCall: {
    id: 'expozed.contactFormCall',
    defaultMessage: 'Call Us',
    description: 'contactForm',
  },
  whyblockTitle1: {
    id: 'expozed.whyblockTitle1',
    defaultMessage: ' What is Lorem Ipsum?',
    description: 'why block Title',
  },
  whyblockTitle2: {
    id: 'expozed.whyblockTitle2',
    defaultMessage: ' This tool for our day to day work and our clients?',
    description: 'why block title',
  },
  whyblockdesc1: {
    id: 'expozed.whyblockdesc1',
    defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
    description: 'why block description',
  },
  whyblockdesc2: {
    id: 'expozed.whyblockdesc2',
    defaultMessage: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ',
    description: 'why block description',
  },
  hostingBlocktitle: {
    id: 'expozed.hostingBlocktitle',
    defaultMessage: 'There are 3 Lorem Ipsum generators',
    description: 'Hosting Block title',
  },
  hostingBlockheading1: {
    id: 'expozed.hostingBlockheading1',
    defaultMessage: ' Lorem Ipsum',
    description: 'Hosting Block heading',
  },
  hostingBlockheading2: {
    id: 'expozed.hostingBlockheading2',
    defaultMessage: ' Lorem Ipsum',
    description: 'Hosting Block heading',
  },
  hostingBlockheading3: {
    id: 'expozed.hostingBlockheading3',
    defaultMessage: ' Lorem Ipsum',
    description: 'Hosting Block heading',
  },
  hostingBlockdesc1: {
    id: 'expozed.hostingBlockdesc1',
    defaultMessage: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
    description: 'Hosting Block Description',
  },
  hostingBlockdesc2: {
    id: 'expozed.hostingBlockdesc2',
    defaultMessage: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
    description: 'Hosting Block Description',
  },
  hostingBlockdesc3: {
    id: 'expozed.hostingBlockdesc3',
    defaultMessage: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
    description: 'Hosting Block Description',
  },
  coverSectiontitle: {
    id: 'expozed.coverSectiontitle',
    defaultMessage: 'Use our generator to get your own',
    description: 'Cover Section Title',
  },
  coverSectiondesc1: {
    id: 'expozed.coverSectiondesc1',
    defaultMessage: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    description: 'Cover Section Description',
  },
  coverSectiondesc2: {
    id: 'expozed.coverSectiondesc2',
    defaultMessage: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    description: 'Cover Section Description',
  },
  coverSectionlistItem1: {
    id: 'expozed.coverSectionlistItem1',
    defaultMessage: 'Excepteur sint occaecat cupidatat non proident',
    description: 'Cover Section List Item',
  },
  coverSectionlistItem2: {
    id: 'expozed.coverSectionlistItem2',
    defaultMessage: 'quis nostrud exercitation ullamco laboris nisi',
    description: 'Cover Section List Item',
  },
  coverSectionlistItem3: {
    id: 'expozed.coverSectionlistItem3',
    defaultMessage: 'Sed ut perspiciatis unde omnis iste natus error sit',
    description: 'Cover Section List Item',
  },
  coverSectionlistItem4: {
    id: 'expozed.coverSectionlistItem4',
    defaultMessage: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur ',
    description: 'Cover Section List Item',
  },
  coverSectionlistItem5: {
    id: 'expozed.coverSectionlistItem5',
    defaultMessage: ' Ut enim ad minima veniam, quis nostrum exercitationem',
    description: 'Cover Section List Item',
  },
  coverSectionlistItem6: {
    id: 'expozed.coverSectionlistItem6',
    defaultMessage: ' Excepteur sint occaecat cupidatat non proident',
    description: 'Cover Section List Item',
  },
  paymentContenttitle: {
    id: 'expozed.paymentContenttitle',
    defaultMessage: 'It to make a type specimen book',
    description: 'payment Content title',
  },
  paymentContentheading1: {
    id: 'expozed.paymentContentheading1',
    defaultMessage: 'Sed ut perspiciatis',
    description: 'payment Content Heading',
  },
  paymentContentheading2: {
    id: 'expozed.paymentContentheading2',
    defaultMessage: 'Nemo enim ipsam',
    description: 'payment Content Heading',
  },
  paymentContentheading3: {
    id: 'expozed.paymentContentheading3',
    defaultMessage: 'Neque porro',
    description: 'payment Content Heading',
  },
  paymentContentdesc1: {
    id: 'expozed.paymentContentdesc1',
    defaultMessage: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur',
    description: 'payment Content Description',
  },
  paymentContentdesc2: {
    id: 'expozed.paymentContentdesc2',
    defaultMessage: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
    description: 'payment Content Description',
  },
  paymentContentdesc3: {
    id: 'expozed.paymentContentdesc3',
    defaultMessage: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
    description: 'payment Content Description',
  },
  quoteText1: {
    id: 'expozed.quoteText1',
    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore',
    description: 'Quote text',
  },
  quotetagline1: {
    id: 'expozed.quotetagline1',
    defaultMessage: ' software like Aldus PageMaker including versions of Lorem Ipsum.',
    description: 'Quote Tag Line',
  },
  quotebutton1: {
    id: 'expozed.quotebutton1',
    defaultMessage: 'Lorem Ipsum Text',
    description: 'Quote Button',
  },
  quoteText2: {
    id: 'expozed.quoteText2',
    defaultMessage: 'It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.',
    description: 'Quote text',
  },
  quotetagline2: {
    id: 'expozed.quotetagline2',
    defaultMessage: ' software like Aldus PageMaker including versions of Lorem Ipsum.',
    description: 'Quote Tag Line',
  },
  quotebutton3: {
    id: 'expozed.quotebutton3',
    defaultMessage: ' Lorem Ipsum Text',
    description: 'Quote Button',
  },
  countingSectiontitle: {
    id: 'expozed.countingSectiontitle',
    defaultMessage: 'Lorem Ipsum as their default model text',
    description: 'Counting Section Title ',
  },
  countingSectiontagline1: {
    id: 'expozed.countingSectiontagline1',
    defaultMessage: ' Lorem ipsum dolor sit amet',
    description: 'Counting Section Tagline ',
  },
  countingSectiontagline2: {
    id: 'expozed.countingSectiontagline2',
    defaultMessage: ' quis nostrud exercitation ullamco',
    description: 'Counting Section Tagline ',
  },
  countingSectiontagline3: {
    id: 'expozed.countingSectiontagline3',
    defaultMessage: 'Neque porro quisquam ',
    description: 'Counting Section Tagline ',
  },
  aboutSectiontitle: {
    id: 'expozed.aboutSectiontitle',
    defaultMessage: ' Lorem Ipsum ',
    description: 'About Section Title ',
  },
  aboutSectionheading1: {
    id: 'expozed.aboutSectionheading1',
    defaultMessage: ' What is Lorem Ipsum?',
    description: 'About Section Heading ',
  },
  aboutSectiondesc1: {
    id: 'expozed.aboutSectiondesc1',
    defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
    description: 'About Section Description ',
  },
  aboutSectionheading2: {
    id: 'expozed.aboutSectionheading2',
    defaultMessage: 'This tool for our day to day work and our clients?',
    description: 'About Section Heading ',
  },
  aboutSectiondesc2: {
    id: 'expozed.aboutSectiondesc2',
    defaultMessage: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ',
    description: 'About Section Description ',
  },
  faqtitle: {
    id: 'expozed.faqtitle',
    defaultMessage: ' FAQ',
    description: 'Faq  title ',
  },
  faqcollapsetitle1: {
    id: 'expozed.faqcollapsetitle1',
    defaultMessage: 'Lorem ipsum dolor sit amet, consecteturt',
    description: 'Faq collapse title ',
  },
  faqcollapseContent1: {
    id: 'expozed.faqcollapseContent1',
    defaultMessage: ' Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle2: {
    id: 'expozed.faqcollapsetitle2',
    defaultMessage: ' sed do eiusmod tempor incididunt ut labore et',
    description: 'Faq collapse title ',
  },
  faqcollapseContent2: {
    id: 'expozed.faqcollapseContent2',
    defaultMessage: ' Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle3: {
    id: 'expozed.faqcollapsetitle3',
    defaultMessage: ' Ut enim ad minim veniam',
    description: 'Faq collapse title ',
  },
  faqcollapseContent3: {
    id: 'expozed.faqcollapseContent3',
    defaultMessage: 'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle4: {
    id: 'expozed.faqcollapsetitle4',
    defaultMessage: ' Lorem ipsum dolor sit amet, consecteturt',
    description: 'Faq collapse title ',
  },
  faqcollapseContent4: {
    id: 'expozed.faqcollapseContent4',
    defaultMessage: 'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle5: {
    id: 'expozed.faqcollapsetitle5',
    defaultMessage: 'Lorem ipsum dolor sit amet, consecteturt',
    description: 'Faq collapse title ',
  },
  faqcollapseContent5: {
    id: 'expozed.faqcollapseContent5',
    defaultMessage: ' Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle6: {
    id: 'expozed.faqcollapsetitle6',
    defaultMessage: 'sed do eiusmod tempor incididunt ut labore et',
    description: 'Faq collapse title ',
  },
  faqcollapseContent6: {
    id: 'expozed.faqcollapseContent6',
    defaultMessage: 'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle7: {
    id: 'expozed.faqcollapsetitle7',
    defaultMessage: ' Ut enim ad minim veniam',
    description: 'Faq collapse title ',
  },
  faqcollapseContent7: {
    id: 'expozed.faqcollapseContent7',
    defaultMessage: 'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },
  faqcollapsetitle8: {
    id: 'expozed.faqcollapsetitle8',
    defaultMessage: 'Lorem ipsum dolor sit amet, consecteturt',
    description: 'Faq collapse title ',
  },
  faqcollapseContent8: {
    id: 'expozed.faqcollapseContent8',
    defaultMessage: ' Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim   esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    description: 'Faq collapse Content ',
  },

  contactFormAddress: {
    id: 'expozed.contactFormAddress',
    defaultMessage: 'Contact Address',
    description: 'Contact Address',
  },

  showDescription: {
    id: 'expozed.showDescription',
    defaultMessage: 'Show description',
    description: 'View Listing',
  },
  hideDescription: {
    id: 'expozed.hideDescription',
    defaultMessage: 'Hide description',
    description: 'View Listing',
  },
  showAllSafetyFeatures: {
    id: 'expozed.showAllSafetyFeatures',
    defaultMessage: 'Show all safety features',
    description: 'Toggle Button',
  },
  showAllSharedSpaces: {
    id: 'expozed.showAllSharedSpaces',
    defaultMessage: 'Show all shared spaces',
    description: 'Toggle Button',
  },
  closeAllSharedSpaces: {
    id: 'expozed.closeAllSharedSpaces',
    defaultMessage: 'Close all shared spaces',
    description: 'Toggle Button',
  },
  nightOf: {
    id: 'expozed.nightOf',
    defaultMessage: 'Night of',
    description: 'Night of',
  },
  Youhadreviewsfor: {
    id: 'expozed.Youhadreviewsfor',
    defaultMessage: 'You reviewed',
    description: 'You reviewed',
  },
  sreview: {
    id: 'expozed.sreview',
    defaultMessage: 's review',
    description: 's review',
  },
  youLabel: {
    id: 'expozed.youLabel',
    defaultMessage: 'You',
    description: 'Review',
  },
  exceedLimit: {
    id: 'expozed.exceedLimit',
    defaultMessage: 'Limit Exceeded',
    description: 'exceedLimit',
  },
  enableLabel: {
    id: 'expozed.enableLabel',
    defaultMessage: 'Enable',
    description: 'Enable',
  },
  disableLabel: {
    id: 'expozed.disableLabel',
    defaultMessage: 'Disable',
    description: 'Disable',
  },
  removeDateError: {
    id: 'expozed.removeDateError',
    defaultMessage: 'Please choose the blocked or special pricing dates to make them available.',
    description: 'Remove date from special pricing error message',
  },
  unBlockInfo: {
    id: 'expozed.unBlockInfo',
    defaultMessage: 'Note: To unblock a date, select any blocked or available date and save without giving special price.',
    description: 'calendar unblock info'
  },
  zipcodeOne: {
    id: 'expozed.zipcodeOne',
    defaultMessage: 'ZIP',
    description: 'ZIP Code',
  },
  cancellationPoliciesOne: {
    id: 'expozed.cancellationPoliciesOne',
    defaultMessage: 'allows hosts to choose among three standardized cancellation policies (Flexible, Moderate, and Strict) Will be enforced to protect both guest and host alike.',
    description: 'Cancellation Policies',
  },
  cancellationPoliciesTwo: {
    id: 'expozed.cancellationPoliciesTwo',
    defaultMessage: 'Each listing and reservation on our site will clearly state the cancellation policy. Guests while viewing their travel plans are able to review any penalties and also cancel by clicking  ‘Cancel’ on the respective reservation.',
    description: 'Cancellation Policies',
  },
  cancellationPoliciesThree: {
    id: 'expozed.cancellationPoliciesThree',
    defaultMessage: 'A host will be able to see the number of reservations a guest has Cancelled Over the past 12 months when the guest submits Booking request.',
    description: 'Cancellation Policies',
  },
  localLawsOne: {
    id: 'expozed.localLawsOne',
    defaultMessage: 'Take a moment to review your local laws. We want to make sure you’ve got everything you need to get off to a great start.',
    description: 'Lowcal Law',
  },
  localLawsTwo: {
    id: 'expozed.localLawsTwo',
    defaultMessage: 'Please educate yourself about the laws in your jurisdiction before listing your space.',
    description: 'Lowcal Law',
  },
  localLawsThree: {
    id: 'expozed.localLawsThree',
    defaultMessage: 'Most cities have rules covering homesharing, and the specific codes and ordinances can appear in many places (such as zoning, building, licensing or tax codes). In most places, you must register, get a permit, or obtain a license before you list your property or accept guests. You may also be responsible for collecting and remitting certain taxes. In some places, short-term rentals could be prohibited altogether.',
    description: 'Lowcal Law',
  },
  localLawsFour: {
    id: 'expozed.localLawsFour',
    defaultMessage: 'Most cities have rules covering homesharing, and the specific codes and ordinances can appear in many places (such as zoning, building, licensing or tax codes). In most places, you must register, get a permit, or obtain a license before you list your property or accept guests. You may also be responsible for collecting and remitting certain taxes. In some places, short-term rentals could be prohibited altogether.',
    description: 'Lowcal Law',
  },
  localLawsFive: {
    id: 'expozed.localLawsFive',
    defaultMessage: 'Since you are responsible for your own decision to list or book, you should get comfortable with the applicable rules before listing on',
    description: 'Lowcal Law',
  },
  localLawsSix: {
    id: 'expozed.localLawsSix',
    defaultMessage: 'To get you started, we offer some helpful resources under “Your City Laws.”',
    description: 'Lowcal Law',
  },
  localLawsSeven: {
    id: 'expozed.localLawsSeven',
    defaultMessage: 'By accepting our Terms of Service and listing your space, you certify that you will follow applicable laws and regulations.',
    description: 'Lowcal Law',
  },
  flexibleTitle: {
    id: 'expozed.flexibleTitle',
    defaultMessage: 'Flexible: Full refund 1 day prior to arrival',
    description: 'Flexible',
  },
  cancelDetailsOne: {
    id: 'expozed.flexibleOne',
    defaultMessage: 'Cleaning fees are always refunded if the guest did not check in.',
    description: 'Flexible',
  },
  cancelDetailsTwo: {
    id: 'expozed.flexibleTwo',
    defaultMessage: 'The',
    description: 'Flexible',
  },
  cancelDetailsThree: {
    id: 'expozed.flexibleThree',
    defaultMessage: 'service fee is refundable if the guest cancels before the trip starts. If a guest books a reservation that overlaps with any part of an existing reservation, we won’t refund the',
    description: 'Flexible',
  },
  cancelDetailsFour: {
    id: 'expozed.flexibleFour',
    defaultMessage: 'service fee if they decide to cancel.',
    description: 'Flexible',
  },
  cancelDetailsFive: {
    id: 'expozed.flexibleFive',
    defaultMessage: 'Accommodation fees (the total nightly rate you\'re charged) are refundable in certain circumstances as outlined below.',
    description: 'Flexible',
  },
  cancelDetailsSix: {
    id: 'expozed.flexibleSix',
    defaultMessage: 'If there is a complaint from either party, notice must be given to',
    description: 'Flexible',
  },
  cancelDetailsSeven: {
    id: 'expozed.flexibleSeven',
    defaultMessage: 'within 24 hours of check-in.',
    description: 'Flexible',
  },
  cancelDetailsEight: {
    id: 'expozed.flexibleEight',
    defaultMessage: 'will mediate when necessary, and has the final say in all disputes.',
    description: 'Flexible',
  },
  cancelDetailsNine: {
    id: 'expozed.flexibleNine',
    defaultMessage: 'A reservation is officially canceled when the guest clicks the cancellation button on the cancellation confirmation page, which they can find in Dashboard > Your Trips > Cancel.',
    description: 'Flexible',
  },
  cancelDetailsTen: {
    id: 'expozed.flexibleTen',
    defaultMessage: 'Cancellation policies may be superseded by the Guest Refund Policy, extenuating circumstances, or cancellations by',
    description: 'Flexible',
  },
  cancelDetailsEleven: {
    id: 'expozed.flexibleEleven',
    defaultMessage: 'Applicable taxes will be retained and remitted.',
    description: 'Flexible',
  },
  cancelDetailsTwelve: {
    id: 'expozed.cancelDetailsTwelve',
    defaultMessage: 'for any other reason permitted under the Terms of Service. Please review these exceptions.',
    description: 'Flexible',
  },
  dayPrior: {
    id: 'expozed.dayPrior',
    defaultMessage: 'day Prior',
    description: 'Flexible',
  },
  months: {
    id: 'expozed.months',
    defaultMessage: 'Thu, Jun',
    description: 'Flexible',
  },
  flexibleTime: {
    id: 'expozed.flexibleTime',
    defaultMessage: 'PM',
    description: 'Flexible',
  },
  flexibleTwelve: {
    id: 'expozed.flexibleTwelve',
    defaultMessage: 'For a full refund of accommodation fees, cancellation must be made a full 24 hours prior to listing’s local check in time (or 3:00 PM if not specified) on the day of check in. For example, if check-in is on Friday, cancel by Thursday of that week before check in time.',
    description: 'Flexible',
  },
  flexibleThirteen: {
    id: 'expozed.flexibleThirteen',
    defaultMessage: 'If the guest cancels less than 24 hours before check-in, the first night is non-refundable.',
    description: 'Flexible',
  },
  flexibleFourteen: {
    id: 'expozed.flexibleFourteen',
    defaultMessage: 'If the guest arrives and decides to leave early, the accommodation fees for the nights not spent 24 hours after the official cancellation are fully refunded.',
    description: 'Flexible',
  },
  example: {
    id: 'expozed.example',
    defaultMessage: 'Example',
    description: 'Flexible',
  },
  flexibleSecondMonths: {
    id: 'expozed.flexibleSecondMonths',
    defaultMessage: 'Fri, Jun',
    description: 'Flexible',
  },
  flexibleSecondTime: {
    id: 'expozed.flexibleSecondTime',
    defaultMessage: 'AM',
    description: 'Flexible',
  },
  flexibleThirdMonths: {
    id: 'expozed.flexibleThirdMonths',
    defaultMessage: 'Mon, Jun',
    description: 'Flexible',
  },
  flexibleThirdMonthsNumberOne: {
    id: 'expozed.flexibleThirdMonthsNumberOne',
    defaultMessage: '08',
    description: 'Flexible',
  },
  flexibleThirdMonthsNumberTwo: {
    id: 'expozed.flexibleThirdMonthsNumberTwo',
    defaultMessage: '09',
    description: 'Flexible',
  },
  flexibleThirdMonthsNumberThree: {
    id: 'expozed.flexibleThirdMonthsNumberThree',
    defaultMessage: '12',
    description: 'Flexible',
  },
  flexibleThirdMonthsTimeOne: {
    id: 'expozed.flexibleThirdMonthsTimeOne',
    defaultMessage: '3:00',
    description: 'Flexible',
  },
  flexibleThirdMonthsTimeTwo: {
    id: 'expozed.flexibleThirdMonthsTimeTwo',
    defaultMessage: '11.00',
    description: 'Flexible',
  },
  moderateTitle: {
    id: 'expozed.moderateTitle',
    defaultMessage: 'Moderate: Full refund 5 days prior to arrival',
    description: 'Moderate',
  },
  daysPrior: {
    id: 'expozed.daysPrior',
    defaultMessage: 'days Prior',
    description: 'Moderate',
  },
  moderateOne: {
    id: 'expozed.moderateOne',
    defaultMessage: 'For a full refund of accommodation fees, cancellation must be made five full days prior to listing’s local check in time (or 3:00 PM if not specified) on the day of check in. For example, if check-in is on Friday, cancel by the previous Sunday before check in time.',
    description: 'Moderate',
  },
  moderateTwo: {
    id: 'expozed.moderateTwo',
    defaultMessage: 'If the guest cancels less than 5 days in advance, the first night is non-refundable but 50% of the accommodation fees for remaining nights will be refunded.',
    description: 'Moderate',
  },
  moderateThree: {
    id: 'expozed.moderateThree',
    defaultMessage: 'If the guest arrives and decides to leave early, 50% of the accommodation fees for the nights not spent 24 hours after the cancellation occurs are refunded.',
    description: 'Moderate',
  },
  moderateMonthsNumberOne: {
    id: 'expozed.moderateMonthsNumberOne',
    defaultMessage: '13',
    description: 'Flexible',
  },
  moderateMonthsNumberTwo: {
    id: 'expozed.moderateMonthsNumberTwo',
    defaultMessage: '16',
    description: 'Flexible',
  },
  strictTitle: {
    id: 'expozed.strictTitle',
    defaultMessage: 'Strict: 50% refund up until 1 week prior to arrival',
    description: 'Moderate',
  },
  strictOne: {
    id: 'expozed.strictOne',
    defaultMessage: 'For a 50% refund of accommodation fees, cancellation must be made seven full days prior to listing’s local check in time (or 3:00 PM if not specified) on the day of check in, otherwise no refund. For example, if check-in is on Friday, cancel by Friday of the previous week before check in time.',
    description: 'Moderate',
  },
  strictTwo: {
    id: 'expozed.strictTwo',
    defaultMessage: 'If the guest cancels less than 7 days in advance, the remaining nights are not refunded.',
    description: 'Moderate',
  },
  strictThree: {
    id: 'expozed.strictThree',
    defaultMessage: 'If the guest arrives and decides to leave early, the remaining nights are not refunded.',
    description: 'Moderate',
  },
  strictMonthsOne: {
    id: 'expozed.strictMonthsOne',
    defaultMessage: '15',
    description: 'Moderate',
  },
  strictMonthsTwo: {
    id: 'expozed.strictMonthsTwo',
    defaultMessage: '18',
    description: 'Moderate',
  },
  spaceFreeOne: {
    id: 'expozed.spaceFreeOne',
    defaultMessage: 'Find out how much you could earn hosting your place',
    description: 'Space Free',
  },
  spaceFreeTwo: {
    id: 'expozed.spaceFreeTwo',
    defaultMessage: 'Turn your extra space into extra income.',
    description: 'Space Free',
  },
  freeOutMore: {
    id: 'expozed.freeOutMore',
    defaultMessage: 'Find out more',
    description: 'Space Free',
  },
  ListPlaceTipOne: {
    id: 'expozed.ListPlaceTipOne',
    defaultMessage: 'Entire place',
    description: 'List Plce Tips',
  },
  ListPlaceTipsTwo: {
    id: 'expozed.ListPlaceTipsTwo',
    defaultMessage: 'Guests will rent the entire place. Includes in-law units.',
    description: 'List Plce Tips',
  },
  ListPlaceTip3: {
    id: 'expozed.ListPlaceTip3',
    defaultMessage: 'Lorem Ipsum Text',
    description: 'List Plce Tips',
  },
  ListPlaceTips4: {
    id: 'expozed.ListPlaceTips4',
    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'List Plce Tips',
  },
  ListPlaceTip5: {
    id: 'expozed.ListPlaceTip5',
    defaultMessage: 'Excepteur sint occaecat',
    description: 'List Plce Tips',
  },
  ListPlaceTips6: {
    id: 'expozed.ListPlaceTips6',
    defaultMessage: 'sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    description: 'List Plce Tips',
  },
  removeFile: {
    id: 'expozed.removeFile',
    defaultMessage: 'Remove file',
    description: 'Remove file',
  },
  Sayyourspace: {
    id: 'expozed.Sayyourspace',
    defaultMessage: 'Say your space',
    description: 'Sayyourspace',
  },
  aboutDescPayment: {
    id: 'expozed.aboutDescPayment',
    defaultMessage: 'Tell your expectations and the number of guests you are bringing with you so that the host can make your trip an organized and a perfect trip you ever had!',
    description: 'Sayyourspace',
  },
  availableLabel: {
    id: 'expozed.availableLabel',
    defaultMessage: 'Available',
    description: 'Listing Step3'
  },
  blockLabel: {
    id: 'expozed.blockLabel',
    defaultMessage: 'Block',
    description: 'Listing Step3'
  },
  coverLabel: {
    id: 'expozed.coverLabel',
    defaultMessage: 'Cover',
    description: 'Listing Step2'
  },
  warningLabel: {
    id: 'expozed.warningLabel',
    defaultMessage: 'Something went wrong!',
    description: 'Warning'
  },
  completeRequest: {
    id: 'expozed.completeRequest',
    defaultMessage: 'We couldn\'t complete your request',
    description: 'Warning'
  },
  errorCodeWarning: {
    id: 'expozed.errorCodeWarning',
    defaultMessage: 'Error code:',
    description: 'Warning'
  },
  helpfulLinks: {
    id: 'expozed.helpfulLinks',
    defaultMessage: 'Here are some helpful links instead:',
    description: 'Warning'
  },
  chooseLanguage: {
    id: 'expozed.chooseLanguage',
    defaultMessage: 'Choose a Language',
    description: 'Choose a Language',
  },
  chooseACurrency: {
    id: 'expozed.chooseACurrency',
    defaultMessage: 'Choose a Currency',
    description: 'Choose a Currency',
  },
  payoutFailure: {
    id: 'expozed.payoutFailure',
    defaultMessage: 'Oops! We are sorry!',
    description: 'Uh-oh, the registration has failed.',
  },
  payoutFailureSubtitle: {
    id: 'expozed.payoutFailureSubtitle',
    defaultMessage: 'Connecting your bank account with the platform verification is failed.',
    description: 'Please add a valid SSN.'
  },
  payoutFailureContent: {
    id: 'expozed.payoutFailureContent',
    defaultMessage: 'Please try again to add your bank account with the platform by clickting the "Retry" option or Add a new payout account by clicking the "Add Payout Method".',
    description: 'Please add a valid SSN.'
  },
  paymentCardNumber: {
    id: 'expozed.paymentCardNumber',
    defaultMessage: 'Card Number',
    description: 'cardNumber',
  },
  payoutType: {
    id: 'expozed.payoutType',
    defaultMessage: 'Account Type',
    description: 'payout Account Type',
  },
  payoutIndividual: {
    id: 'expozed.payoutIndividual',
    defaultMessage: 'Individual',
    description: 'Individual text',
  },
  payoutCompany: {
    id: 'expozed.payoutCompany',
    defaultMessage: 'Company',
    description: 'Company text',
  },
  payoutCompanyName: {
    id: 'expozed.payoutCompanyName',
    defaultMessage: 'Company Name',
    description: 'Company text',
  },
  payoutStripeInfo: {
    id: 'expozed.payoutStripeInfo',
    defaultMessage: 'We use Stripe to make sure you get paid on time and to keep your personal bank and details secure. Click "Finish" to set up your payments on Stripe.',
    description: 'Stripe text info'
  },
  notReady: {
    id: 'expozed.notReady',
    defaultMessage: 'Not Ready',
    description: 'Payout Method',
  },
  payoutVerify: {
    id: 'expozed.payoutVerify',
    defaultMessage: 'Verify',
    description: 'Payout Method',
  },
  payoutRetry: {
    id: 'expozed.payoutRetry',
    defaultMessage: 'Retry',
    description: 'Payout Method',
  },
  payoutVerifyStripeInfo: {
    id: 'expozed.payoutVerifyStripeInfo',
    defaultMessage: 'We use Stripe to make sure you get paid on time safe and secure. It requires additional verification to connect your bank account with the platform.',
    description: 'Payout Method',
  },
  reservationIsCompleted: {
    id: 'expozed.reservationIsCompleted',
    defaultMessage: 'Reservation is completed',
    description: 'View message action',
  },
  reservationIsCompletedDescription: {
    id: 'expozed.reservationIsCompletedDescription',
    defaultMessage: 'Reservation of your listing is completed.',
    description: 'View message action',
  },
  averagePriceperDay: {
    id: 'expozed.averagePriceperDay',
    defaultMessage: 'Average rate per night for your trip.',
    description: 'Tooltip'
  },
  exportCalendar: {
    id: 'expozed.exportCalendar',
    defaultMessage: 'Export Calendar',
    description: 'exportCalendar',
  },
  exportCalendarDescription: {
    id: 'expozed.exportCalendarDescription',
    defaultMessage: 'Copy and paste the link into other ICAL applications',
    description: 'exportCalendar',
  },
  importCalendar: {
    id: 'expozed.importCalendar',
    defaultMessage: 'Import a New Calendar',
    description: 'importCalendar',
  },
  importCalendarDesc: {
    id: 'expozed.importCalendarDesc',
    defaultMessage: 'Import other calendars you use and we’ll automatically keep this listing’s availability up-to-date.',
    description: 'importCalendar',
  },
  importCalendarDesc1: {
    id: 'expozed.importCalendarDesc1',
    defaultMessage: 'Calendar Address (URL)',
    description: 'importCalendar',
  },
  importCalendarDesc2: {
    id: 'expozed.importCalendarDesc2',
    defaultMessage: 'Calendar Address (URL)',
    description: 'importCalendar',
  },
  importCalendarBtn: {
    id: 'expozed.importCalendarBtn',
    defaultMessage: 'Import Calendar',
    description: 'importCalendar',
  },
  booked: {
    id: 'expozed.booked',
    defaultMessage: 'Booked',
    description: 'Calendar',
  },
  notAvailable: {
    id: 'expozed.notAvailable',
    defaultMessage: 'Not Available',
    description: 'Calendar',
  },
  discountStays: {
    id: 'expozed.discountStays',
    defaultMessage: 'Discount for longer stay',
    description: 'Discount',
  },
  yesText: {
    id: 'expozed.yesText',
    defaultMessage: 'Yes',
    description: 'yes',
  },
  noText: {
    id: 'expozed.noText',
    defaultMessage: 'No',
    description: 'No',
  },
  verificationDesc: {
    id: 'expozed.verificationDesc',
    defaultMessage: 'If it doesn\'t arrive, click cancel and try again.',
    description: 'Verification',
  },
  confirmedLabel: {
    id: 'expozed.confirmedLabel',
    defaultMessage: 'Confirmed',
    description: 'Confirmed',
  },
  uploadSizedLabel: {
    id: 'expozed.uploadSizedLabel',
    defaultMessage: 'Maximum upload size:',
    description: 'uploadSizedLabel',
  },
  recepitInfoDesc: {
    id: 'expozed.recepitInfoDesc',
    defaultMessage: 'Average rate per night for your trip.',
    description: 'Receipt Info',
  },
  showMap: {
    id: 'expozed.showMap',
    defaultMessage: 'Show Map',
    description: 'showMap',
  },
  shareModal: {
    id: 'expozed.shareModal',
    defaultMessage: 'Modal',
    description: 'shareModal',
  },
  shareLabel: {
    id: 'expozed.shareLabel',
    defaultMessage: 'Share',
    description: 'shareLabel',
  },
  emailLabel: {
    id: 'expozed.emailLabel',
    defaultMessage: 'Email',
    description: 'emailLabel',
  },
  inLabel: {
    id: 'expozed.inLabel',
    defaultMessage: 'in',
    description: 'inLabel',
  },
  socialShareDesc: {
    id: 'expozed.socialShareDesc',
    defaultMessage: 'Check out this awesome listing on Expozed',
    description: 'socialShareDesc',
  },
  tripCompleted: {
    id: 'expozed.tripCompleted',
    defaultMessage: 'Trip is completed',
    description: 'tripCompleted',
  },
  countingSectionNumberOne: {
    id: 'expozed.countingSectionNumberOne',
    defaultMessage: '2.9M',
    description: '2.9M',
  },
  countingSectionNumberTwo: {
    id: 'expozed.countingSectionNumberTwo',
    defaultMessage: '800K',
    description: '800K',
  },
  countingSectionNumberThree: {
    id: 'expozed.countingSectionNumberThree',
    defaultMessage: '14K',
    description: '14K',
  },
  readyToEarn: {
    id: 'expozed.readyToEarn',
    defaultMessage: 'Ready to earn?',
    description: 'Ready to earn?',
  },
  readyToEarnDesc: {
    id: 'expozed.readyToEarnDesc',
    defaultMessage: 'Get started',
    description: 'Ready to earn?',
  },
  companyName: {
    "id": "expozed.companyName",
    "description": "User Company name",
    "defaultMessage": "Company name",
  },
  
  zip: {
    "id": "expozed.zip",
    "description": "User Zip",
    "defaultMessage": "Zip",
  },
  taxId: {
    "id": "expozed.taxId",
    "description": "User Tax Id",
    "defaultMessage": "Tax Id",
  },
  today: {
    "id": "expozed.today",
    "description": "today",
    "defaultMessage": "today",
  },
  of: {
    "id": "expozed.of",
    "description": "of",
    "defaultMessage": "of",
  },
  willBeApproved: {
    "id": "expozed.willBeApproved",
    "description": "Before we put your listing live we do a manual review process first",
    "defaultMessage": "Before we put your listing live we do a manual review process first",
  },
  contactPerson: {
    "id": "expozed.contactPerson",
    "description": "Contact Person",
    "defaultMessage": "Contact person",
  },
  companyInfo: {
    "id": "expozed.companyInfo",
    "description": "Company info",
    "defaultMessage": "Company info",
  },
  calendarButton: {
    "id": "expozed.calendarButton",
    "description": "Calendar Button",
    "defaultMessage": "Show Listing Calendar",
  },
  instantBookTooltip: {
    "id": "expozed.instantBookTooltip",
    "description": "Instant bookable",
    "defaultMessage": "Directly bookable",
  },
  inReview: {
    "id": "expozed.inReview",
    "description": "In Review",
    "defaultMessage": "In Review",
  },
  inReviewProcess: {
    "id": "expozed.inReviewProcess",
    "description": "Your item will be reviewed by our team",
    "defaultMessage": "Your item will be reviewed by our team.",
  },
  buildingCondition: {
    "id": "expozed.buildingCondition",
    "description": "Building condition",
    "defaultMessage": "Building condition",
  },
  floorCount: {
    "id": "expozed.floorCount",
    "description": "Number of floors",
    "defaultMessage": "Number of floors",
  },
  parkingCount: {
    "id": "expozed.parkingCount",
    "description": "Number of parking spaces",
    "defaultMessage": "Number of parking spaces",
  },
  floorHeight: {
    "id": "expozed.floorHeight",
    "description": "Floor Height",
    "defaultMessage": "Floor height",
  },
  floorLoading: {
    "id": "expozed.floorLoading",
    "description": "Floor loading",
    "defaultMessage": "Floor loading",
  },
  flooring: {
    "id": "expozed.flooring",
    "description": "Flooring",
    "defaultMessage": "Flooring",
  },
  buildingType: {
    "id": "expozed.buildingType",
    "description": "Building Type",
    "defaultMessage": "Building Type",
  },
  buildingType2: {
    "id": "expozed.buildingType2",
    "description": "Building Type2",
    "defaultMessage": "Building Type2",
  },
  storageRack: {
    "id": "expozed.storageRack",
    "description": "Storage rack",
    "defaultMessage": "Storage rack",
  },
  storageRack2: {
    "id": "expozed.storageRack2",
    "description": "Storage rack",
    "defaultMessage": "Storage rack",
  },
  storageRackDescription: {
    "id": "expozed.storageRackDescription",
    "description": "Storage rack description",
    "defaultMessage": "Storage rack description",
  },
  listingAdditionalInfo: {
    "id": "expozed.listingAdditionalInfo",
    "description": "Listing additional info",
    "defaultMessage": "Listing additional info",
  },
  qmPrice: {
    "id": "expozed.qmPrice",
    "description": "Squaremeter price",
    "defaultMessage": "Squaremeter price",
  }, 
  nkPrice: {
    "id": "expozed.nkPrice",
    "description": "Additional costs per year",
    "defaultMessage": "Additional costs per year",
  },
  theListing: {
    "id": "expozed.theListing",
    "description": "Das Mietobjekt",
    "defaultMessage": "Das Mietobjekt",
  },
  storageSpace: {
    "id": "expozed.storageSpace",
    "description": "Lagerfläche",
    "defaultMessage": "Lagerfläche",
  },
  totalArea: {
    "id": "expozed.totalArea",
    "description": "Gesamtfläche",
    "defaultMessage": "Gesamtfläche",
  },
  validationPersonCapacity: {
    "id": "expozed.validationPersonCapacity",
    "description": "Please insert a value between 50 and 10.000",
    "defaultMessage": "Bitte geben Sie einen Wert zwischen 250 und 10.000 ein",
  },
  notANumber: {
    "id": "expozed.notANumber",
    "description": "Please insert a number",
    "defaultMessage": "Bitte geben Sie eine Zahl ein",
  },
  notAFullNumber: {
    "id": "expozed.notAFullNumber",
    "description": "Please insert full numbers only",
    "defaultMessage": "Bitte geben Sie nur ganze Zahlen ein",
  },
  only2decimals: {
    "id": "expozed.only2decimals",
    "description": "Bitte verwenden sie max. 2 Dezimalstellen",
    "defaultMessage": "Bitte verwenden sie max. 2 Dezimalstellen",
  },
  validationfloorHeight: {
    "id": "expozed.validationfloorHeight",
    "description": "Please insert a value between 0 and 15",
    "defaultMessage": "Bitte geben Sie einen Wert zwischen 2m und 25m ein",
  },
  powerConnection: {
    "id": "expozed.powerConnection",
    "description": "Power connection",
    "defaultMessage": "Power connection",
  },
  lighting: {
    "id": "expozed.lighting",
    "description": "Lighting",
    "defaultMessage": "Lighting",
  },
  buildingClimate: {
    "id": "expozed.buildingClimate",
    "description": "Building climate",
    "defaultMessage": "Building climate",
  },
  truckDock: {
    "id": "expozed.truckDock",
    "description": "Truck Dock",
    "defaultMessage": "Truck Dock",
  },
  truckDocks: {
    "id": "expozed.truckDocks",
    "description": "Truck Docks",
    "defaultMessage": "Truck Docks",
  },
 
  ramp: {
    "id": "expozed.ramp",
    "description": "Ramp",
    "defaultMessage": "Ramp",
  },
  ramps: {
    "id": "expozed.ramps",
    "description": "Ramps",
    "defaultMessage": "Ramps",
  },
 
  gate: {
    "id": "expozed.gate",
    "description": "Gate",
    "defaultMessage": "Gate",
  },
  gates: {
    "id": "expozed.gates",
    "description": "Gates",
    "defaultMessage": "Gates",
  },
  door: {
    "id": "expozed.door",
    "description": "Door",
    "defaultMessage": "Door",
  },
  doors: {
    "id": "expozed.doors",
    "description": "Doors",
    "defaultMessage": "Doors",
  },
  averagePricePerNight: {
    "id": "expozed.averagePricePerNight",
    "description": "Average price per night",
    "defaultMessage": "Average price per night",
  },
  accessPoints: {
    "id": "expozed.accessPoints",
    "description": "Accesspoints",
    "defaultMessage": "Accesspoints",
  },
  region: {
    "id": "expozed.region",
    "description": "Region",
    "defaultMessage": "Region",
  },
  nationality: {
    "id": "expozed.nationality",
    "description": "Nationality",
    "defaultMessage": "Nationality",
  },
  completeProfile: {
    "id": "expozed.completeProfile",
    "description": "Complete Profile",
    "defaultMessage": "Complete Profile",
  },
  kycIdentityProof: {
    "id": "expozed.kycIdentityProof",
    "description": "KYC Identity Proof",
    "defaultMessage": "KYC Identity Proof",
  },
  kycIdentityProofText: {
    "id": "expozed.kycIdentityProofText",
    "description": "KYC Identity Proof Text",
    "defaultMessage": "KYC Identity Proof Text",
  },
  kycArticlesOfAssociation: {
    "id": "expozed.kycArticlesOfAssociation",
    "description": "KYC Articles Of Association",
    "defaultMessage": "KYC Articles Of Association",
  },
  kycArticlesOfAssociationText: {
    "id": "expozed.kycArticlesOfAssociationText",
    "description": "KYC Articles Of Association Text",
    "defaultMessage": "KYC Articles Of Association Text",
  },
  kycRegistrationProof: {
    "id": "expozed.kycRegistrationProof",
    "description": "KYC Registration Proof",
    "defaultMessage": "KYC Registration Proof",
  },
  kycRegistrationProofText: {
    "id": "expozed.kycRegistrationProofText",
    "description": "KYC Registration Proof Text",
    "defaultMessage": "KYC Registration Proof Text",
  },
  completeProfileFirst: {
    "id": "expozed.completeProfileFirst",
    "description": "Complete Profile First",
    "defaultMessage": "Complete Profile First",
  },
  kycSubmitButton: {
    "id": "expozed.kycSubmitButton",
    "description": "Submit for Validation",
    "defaultMessage": "Submit for Validation",
  },
  kycSubmitted: {
    "id": "expozed.kycSubmitted",
    "description": "Submitted",
    "defaultMessage": "Submitted",
  },
  kycValidated: {
    "id": "expozed.kycValidated",
    "description": "Validated",
    "defaultMessage": "Validated",
  },
  ibanInvalid: {
    "id": "expozed.ibanInvalid",
    "description": "IBAN invalid",
    "defaultMessage": "IBAN invalid",
  },
  bicInvalid: {
    "id": "expozed.bicInvalid",
    "description": "BIC invalid",
    "defaultMessage": "BIC invalid",
  },
  bic: {
    "id": "expozed.bic",
    "description": "BIC",
    "defaultMessage": "BIC",
  },
  trustInfo: {
    "id": "expozed.trustInfo",
    "description": "Your data is secured",
    "defaultMessage": "Your data is secured",
  },
  birthcity: {
    "id": "expozed.birthcity",
    "description": "City Of Birth",
    "defaultMessage": "City Of Birth",
  },
  birthcountry: {
    "id": "expozed.birthcountry",
    "description": "Country Of Birth",
    "defaultMessage": "Country Of Birth",
  },
  taxRate: {
    id: 'expozed.taxRate',
    defaultMessage: 'Tax Rate',
    description: 'Tax Rate',
  },
  taxRateLabel: {
    id: 'expozed.taxRateLabel',
    defaultMessage: 'Please add in the appropriate tax rate to cover any local and state taxes you may be responsible for.',
    description: 'Tax Rate Label',
  },
  taxRateInvalidError: {
    id: 'expozed.taxRateInvalidError',
    defaultMessage: 'Invalid tax rate. The tax rate must be between 1% and 99%.',
    description: 'Invalid discount',
  }
});




export default messages;
